
// import React, { useState, useEffect, useMemo } from "react";
// import axios from "axios";
// import { useLoader } from '../../../../context/LoaderProvider.jsx';
// import {
//     getAllSettlementsAPI,
//     updateSettlementStatusAPI,
// } from "../../../Servicefile/AccountManagementService.jsx";
// const Foodsettlementpage = () => {
//     // Filter states
//     const [searchType, setSearchType] = useState("vendorId"); // Default search type
//     const [searchQuery, setSearchQuery] = useState("");
//     const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
//     const [selectedDate, setSelectedDate] = useState("");

//     // Search options for dropdown
//     const searchOptions = [
//         { value: "vendorId", label: "Vendor ID" },
//         { value: "holderName", label: "Vendor Name" },
//         { value: "accountNumber", label: "Account Number" },
//         { value: "ifscCode", label: "IFSC Code" }
//     ];

//     const [invoiceData, setInvoiceData] = useState(null);
//     const [settlements, setSettlements] = useState([]);
//     const [filteredSettlements, setFilteredSettlements] = useState([]);
//     const [showStatusModal, setShowStatusModal] = useState(false);
//     const [selectedSettlement, setSelectedSettlement] = useState(null);
//     const [newStatus, setNewStatus] = useState("");
//     const [remarks, setRemarks] = useState("");
//     const [pytMode, setPytMode] = useState("FT");

//     const { showLoader, hideLoader } = useLoader();

//     // Fetch settlements from API
//     useEffect(() => {
//         fetchSettlements();
//     }, []);

//     const fetchSettlements = async () => {
//         try {
//             showLoader();

//             const res = await getAllSettlementsAPI();

//             const data = res.settlements || res;

//             const dataWithSno = Array.isArray(data)
//                 ? data.map((item, index) => ({
//                     ...item,
//                     sno: index + 1,
//                 }))
//                 : [];

//             setSettlements(dataWithSno);
//             setFilteredSettlements(dataWithSno);
//         } catch (err) {
//             console.error("Error fetching settlements:", err);
//         } finally {
//             hideLoader();
//         }
//     };

//     // Get placeholder text based on search type
//     const getPlaceholderText = () => {
//         switch (searchType) {
//             case "vendorId": return "Search Vendor ID";
//             case "holderName": return "Search Vendor Name";
//             case "accountNumber": return "Search Account Number";
//             case "ifscCode": return "Search IFSC Code";
//             default: return "Search...";
//         }
//     };

//     // Filter data based on selected search type, query, status, and date
//     const searchFilteredData = useMemo(() => {
//         if (!searchQuery.trim() && !selectedStatusFilter && !selectedDate) {
//             return settlements;
//         }

//         const query = searchQuery.toLowerCase().trim();

//         return settlements.filter(item => {
//             // Search filter
//             let searchMatch = true;
//             if (searchQuery.trim()) {
//                 const fieldValue = item[searchType];
//                 searchMatch = fieldValue &&
//                     fieldValue.toString().toLowerCase().includes(query);
//             }

//             // Status filter
//             let statusMatch = true;
//             if (selectedStatusFilter) {
//                 statusMatch = item.paymentStatus === selectedStatusFilter;
//             }

//             // Date filter
//             let dateMatch = true;
//             if (selectedDate) {
//                 const settlementDate = item.settlementDate || "";
//                 dateMatch = settlementDate === selectedDate;
//             }

//             return searchMatch && statusMatch && dateMatch;
//         });
//     }, [settlements, searchType, searchQuery, selectedStatusFilter, selectedDate]);

//     // Update filteredSettlements whenever searchFilteredData changes
//     useEffect(() => {
//         setFilteredSettlements(searchFilteredData);
//     }, [searchFilteredData]);

//     // Clear all filters
//     const clearAllFilters = () => {
//         setSearchQuery("");
//         setSelectedStatusFilter("");
//         setSelectedDate("");
//     };

//     // Get unique statuses for filter dropdown
//     const uniqueStatuses = useMemo(() => {
//         const statuses = settlements.map(item => item.paymentStatus).filter(Boolean);
//         return [...new Set(statuses)].sort();
//     }, [settlements]);

//     // Open status update modal
//     const handleStatusUpdateClick = (settlement) => {
//         setSelectedSettlement(settlement);
//         setNewStatus(settlement.paymentStatus);
//         setRemarks(settlement.remarks || "");
//         setPytMode(settlement.pytMode || "FT");
//         setShowStatusModal(true);
//     };

//     // Update settlement status
//     const handleUpdateStatus = async () => {
//         if (!selectedSettlement || !newStatus) {
//             alert("Please select a status");
//             return;
//         }

//         if (!remarks.trim()) {
//             alert("Please enter remarks for the status update");
//             return;
//         }

//         const settlementId = selectedSettlement.settlementId;

//         // Prepare update data
//         const updateData = {
//             settlementId: settlementId,
//             vendorId: selectedSettlement.vendorId,
//             totalCgst: selectedSettlement.totalCgst || 0,
//             totalSgst: selectedSettlement.totalSgst || 0,
//             totalGrandTotal: selectedSettlement.totalGrandTotal || 0,
//             totalServiceCharges: selectedSettlement.totalServiceCharges || 0,
//             totalPlatformCharges: selectedSettlement.totalPlatformCharges || 0,
//             totalOnlinePayment: selectedSettlement.totalOnlinePayment || 0,
//             totalAmountBeforeTds: selectedSettlement.totalAmountBeforeTds || 0,
//             tdsAmount: selectedSettlement.tdsAmount || 0,
//             amountAfterTds: selectedSettlement.amountAfterTds || 0,
//             amountAfterCash: selectedSettlement.amountAfterCash || 0,
//             finalAmount: selectedSettlement.finalAmount || 0,
//             totalCash: selectedSettlement.totalCash || 0,
//             description: selectedSettlement.description || "",
//             fromDate: selectedSettlement.fromDate || new Date().toISOString(),
//             toDate: selectedSettlement.toDate || new Date().toISOString(),
//             totalVendorPlatformCharges:
//                 selectedSettlement.totalVendorPlatformCharges || 0,
//             totalVendorPlatformChargesGst:
//                 selectedSettlement.totalVendorPlatformChargesGst || 0,
//             holderName: selectedSettlement.holderName || "",
//             accountNumber: selectedSettlement.accountNumber || "",
//             ifscCode: selectedSettlement.ifscCode || "",
//             settlementDate:
//                 selectedSettlement.settlementDate ||
//                 new Date().toISOString().split("T")[0],
//             paymentStatus: newStatus,
//             superadminAccNo: selectedSettlement.superadminAccNo || "",
//             pytMode: pytMode,
//             remarks: remarks,
//             totalWalletPayment: selectedSettlement.totalWalletPayment || 0,
//             commission: selectedSettlement.commission || 0,
//         };

//         try {
//             showLoader();

//             await updateSettlementStatusAPI(settlementId, updateData);

//             alert("Status updated successfully!");

//             // Refresh latest settlements
//             await fetchSettlements();

//             // Reset modal states
//             setShowStatusModal(false);
//             setSelectedSettlement(null);
//             setNewStatus("");
//             setRemarks("");
//             setPytMode("FT");

//         } catch (err) {
//             console.error("Error updating status:", err);

//             alert(
//                 `Failed to update status: ${err.response?.data?.message || err.message
//                 }`
//             );
//         } finally {
//             hideLoader();
//         }
//     };

//     // Fixed export function to export filtered data
//     const handleExport = () => {
//         const exportData = filteredSettlements.length > 0 ? filteredSettlements : settlements;

//         if (exportData.length === 0) {
//             alert("There is no data to export.");
//             return;
//         }

//         const escapeCsvField = (field) => {
//             const str = String(field ?? '');
//             if (str.includes(',') || str.includes('"') || str.includes('\n')) {
//                 return `"${str.replace(/"/g, '""')}"`;
//             }
//             return str;
//         };

//         const headers = [
//             "S.NO",
//             "Vendor ID",
//             "Vendor Name",
//             "Total Sales",
//             "Service Charges",
//             "Commission Charges",
//             "To Settle",
//             "Total Cash",
//             "From Date",
//             "To Date",
//             "Admin Account",
//             "Vendor Account",
//             "IFSC Code",
//             "Settlement Date",
//             "Status",
//             "Payment Mode",
//             "Remarks"
//         ];

//         const csvRows = exportData.map((item) => [
//             item.sno || '',
//             item.vendorId || '',
//             item.holderName || '',
//             item.totalAmountBeforeTds || 0,
//             item.tdsAmount || 0,
//             item.commission || 0,
//             item.finalAmount || 0,
//             item.totalCash || 0,
//             formatDate(item.fromDate),
//             formatDate(item.toDate),
//             item.superadminAccNo || '',
//             item.accountNumber || '',
//             item.ifscCode || '',
//             item.settlementDate || '',
//             item.paymentStatus || '',
//             item.pytMode || 'FT',
//             item.remarks || ''
//         ]);

//         const csvString = [
//             headers.map(escapeCsvField).join(','),
//             ...csvRows.map(row => row.map(escapeCsvField).join(','))
//         ].join('\r\n');

//         const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
//         const url = URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         link.setAttribute("href", url);
//         link.setAttribute("download", "settlements.csv");
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         URL.revokeObjectURL(url);
//     };

//     // Get status badge style
//     const getStatusStyle = (status) => {
//         const baseStyle = {
//             padding: "4px 8px",
//             borderRadius: "12px",
//             fontSize: "12px",
//             fontWeight: "500",
//             display: "inline-block",
//             textTransform: "uppercase"
//         };

//         switch (status) {
//             case "PAID":
//                 return {
//                     ...baseStyle,
//                     backgroundColor: "#4CAF50",
//                     color: "white"
//                 };
//             case "PENDING":
//                 return {
//                     ...baseStyle,
//                     backgroundColor: "#FF9800",
//                     color: "white"
//                 };
//             default:
//                 return {
//                     ...baseStyle,
//                     backgroundColor: "#9E9E9E",
//                     color: "white"
//                 };
//         }
//     };

//     // Get payment mode badge style
//     const getPaymentModeStyle = (mode) => {
//         const baseStyle = {
//             padding: "4px 8px",
//             borderRadius: "4px",
//             fontSize: "12px",
//             fontWeight: "500",
//             display: 'inline-block'
//         };

//         switch (mode) {
//             case "FT":
//                 return {
//                     ...baseStyle,
//                     backgroundColor: "#2196F3",
//                     color: "white"
//                 };
//             case "NEFT":
//                 return {
//                     ...baseStyle,
//                     backgroundColor: "#4CAF50",
//                     color: "white"
//                 };
//             case "RTGS":
//                 return {
//                     ...baseStyle,
//                     backgroundColor: "#9C27B0",
//                     color: "white"
//                 };
//             case "IMPS":
//                 return {
//                     ...baseStyle,
//                     backgroundColor: "#FF9800",
//                     color: "white"
//                 };
//             default:
//                 return {
//                     ...baseStyle,
//                     backgroundColor: "#9E9E9E",
//                     color: "white"
//                 };
//         }
//     };

//     // Format date to display only date part
//     const formatDate = (dateString) => {
//         if (!dateString) return "-";
//         const date = new Date(dateString);
//         return date.toISOString().split("T")[0];
//     };

//     const tableHeaderStyle = {
//         border: "1px solid #ddd",
//         textAlign: "center",
//         fontWeight: "bold",
//         backgroundColor: "rgb(230 109 51)",
//         color: "white",
//         padding: "10px 8px",
//         fontSize: "13px",
//         whiteSpace: "nowrap",
//         position: "sticky",
//         top: 0,
//         zIndex: 10,
//     };
//     const tableCellStyle = {
//         border: "1px solid #ddd",
//         textAlign: "center",
//         padding: "10px 8px",
//         fontSize: "13px",
//         whiteSpace: "nowrap",
//     };

//     // Modal styles
//     const modalOverlayStyle = {
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         backgroundColor: 'rgba(0, 0, 0, 0.5)',
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         zIndex: 9999,
//         padding: '20px',
//     };

//     const modalContentStyle = {
//         backgroundColor: '#fff',
//         borderRadius: '8px',
//         width: '100%',
//         maxWidth: '500px',
//         maxHeight: '90vh',
//         overflowY: 'auto',
//         boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
//     };

//     const modalHeaderStyle = {
//         padding: '20px',
//         borderBottom: '1px solid #eee',
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//     };

//     const modalBodyStyle = {
//         padding: '20px',
//     };

//     return (
//         <div className="container-fluid">
//             <div className="row" style={{ marginTop: "10px" }}>
//                 <div className="col-lg-10" style={{ height: "85vh", overflowY: "auto", scrollbarWidth: "none" }}>
//                     {/* Filters and Export Button - Same as Userdetails */}
//                     <div className="row g-2 mb-1 align-items-center me-0">
//                         {/* Search Type Dropdown and Search Input - Side by Side */}
//                         <div className="col-md-auto col-12">
//                             <div className="d-flex align-items-center" style={{ gap: '10px' }}>
//                                 {/* Search Type Dropdown */}
//                                 <div style={{ minWidth: '150px' }}>
//                                     <select
//                                         className="form-select"
//                                         value={searchType}
//                                         onChange={(e) => setSearchType(e.target.value)}
//                                         style={{ height: "40px" }}
//                                     >
//                                         {searchOptions.map(option => (
//                                             <option key={option.value} value={option.value}>
//                                                 {option.label}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 </div>

//                                 {/* Search Input */}
//                                 <div style={{ minWidth: '200px' }}>
//                                     <input
//                                         type="text"
//                                         className="form-control"
//                                         placeholder={getPlaceholderText()}
//                                         value={searchQuery}
//                                         onChange={(e) => setSearchQuery(e.target.value)}
//                                         style={{ height: "40px" }}
//                                     />
//                                 </div>
//                             </div>
//                         </div>

//                         {/* Status Filter */}
//                         <div className="col-md-auto col-12">
//                             <select
//                                 className="form-select"
//                                 value={selectedStatusFilter}
//                                 onChange={(e) => setSelectedStatusFilter(e.target.value)}
//                                 aria-label="Filter by status"
//                                 style={{ maxWidth: '150px', height: "40px" }}
//                             >
//                                 <option value="">All Status</option>
//                                 {uniqueStatuses.map(status => (
//                                     <option key={status} value={status}>{status}</option>
//                                 ))}
//                             </select>
//                         </div>

//                         {/* Date Filter */}
//                         <div className="col-md-auto col-12">
//                             <input
//                                 className="form-control"
//                                 type="date"
//                                 value={selectedDate}
//                                 onChange={(e) => setSelectedDate(e.target.value)}
//                                 style={{ height: "40px", minWidth: '150px' }}
//                             />
//                         </div>

//                         {/* Clear Filters Button */}
//                         <div className="col-md-auto col-12">
//                             <button
//                                 className="btn"
//                                 onClick={clearAllFilters}
//                                 style={{
//                                     backgroundColor: '#6c757d',
//                                     color: '#fff',
//                                     height: "40px",
//                                     padding: "0 15px"
//                                 }}
//                             >
//                                 Clear Filters
//                             </button>
//                         </div>

//                         {/* Export Button */}
//                         <div className="col-md col-12">
//                             <div className="d-flex justify-content-start justify-content-md-end">
//                                 <button
//                                     onClick={handleExport}
//                                     className="btn"
//                                     style={{
//                                         backgroundColor: 'rgb(230 109 51)',
//                                         color: '#fff',
//                                         height: "40px",
//                                         padding: "0 20px",
//                                         fontWeight: "bold",
//                                     }}
//                                 >
//                                     Export CSV
//                                 </button>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Table Container with Horizontal Scroll */}
//                     <div style={{
//                         width: "100%",
//                         overflowX: "auto",
//                         border: "1px solid #ddd",
//                         borderRadius: "4px",
//                         maxHeight: "60vh",
//                         maxWidth: "1480px",
//                         position: "relative",
//                         marginTop: "10px"
//                     }}>
//                         {/* Table */}
//                         <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "1500px" }}>
//                             <thead>
//                                 <tr>
//                                     <th style={tableHeaderStyle}>S.NO</th>
//                                     <th style={tableHeaderStyle}>Vendor ID</th>
//                                     <th style={tableHeaderStyle}>Total Sales</th>
//                                     <th style={tableHeaderStyle}>Service Charges</th>
//                                     <th style={tableHeaderStyle}>Commission Charges</th>
//                                     <th style={tableHeaderStyle}>To Settle</th>
//                                     <th style={tableHeaderStyle}>Total Cash</th>
//                                     <th style={tableHeaderStyle}>From Date</th>
//                                     <th style={tableHeaderStyle}>To Date</th>
//                                     <th style={tableHeaderStyle}>Admin Acc</th>
//                                     <th style={tableHeaderStyle}>Vendor Name</th>
//                                     <th style={tableHeaderStyle}>Vendor Acc</th>
//                                     <th style={tableHeaderStyle}>IFSC</th>
//                                     <th style={tableHeaderStyle}>Settlement Date</th>
//                                     <th style={tableHeaderStyle}>Status</th>
//                                     <th style={tableHeaderStyle}>Remarks</th>
//                                     <th style={tableHeaderStyle}>Payment Mode</th>
//                                     <th style={tableHeaderStyle}>Actions</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {filteredSettlements.length > 0 ? (
//                                     filteredSettlements.map(item => (
//                                         <tr key={item.settlementId || item.vendorId}>
//                                             <td style={tableCellStyle}>{item.sno || '-'}</td>
//                                             <td style={tableCellStyle}>{item.vendorId}</td>
//                                             <td style={tableCellStyle}>₹{item.totalAmountBeforeTds}</td>
//                                             <td style={tableCellStyle}>
//                                                 {item.tdsAmount > 0 ? `₹${item.tdsAmount}` : "₹0"}
//                                             </td>
//                                             <td style={tableCellStyle}>
//                                                 {item.commission > 0 ? `₹${item.commission}` : "₹0"}
//                                             </td>
//                                             <td style={tableCellStyle}>₹{item.finalAmount}</td>
//                                             <td style={tableCellStyle}>₹{item.totalCash}</td>
//                                             <td style={tableCellStyle}>{formatDate(item.fromDate)}</td>
//                                             <td style={tableCellStyle}>{formatDate(item.toDate)}</td>
//                                             <td style={tableCellStyle}>{item.superadminAccNo}</td>
//                                             <td style={tableCellStyle}>{item.holderName}</td>
//                                             <td style={tableCellStyle}>{item.accountNumber}</td>
//                                             <td style={tableCellStyle}>{item.ifscCode}</td>
//                                             <td style={tableCellStyle}>{item.settlementDate}</td>
//                                             <td style={tableCellStyle}>
//                                                 <span style={getStatusStyle(item.paymentStatus)}>
//                                                     {item.paymentStatus}
//                                                 </span>
//                                             </td>
//                                             <td style={tableCellStyle}>
//                                                 {item.remarks ? (
//                                                     <div style={{
//                                                         maxWidth: '200px',
//                                                         whiteSpace: 'nowrap',
//                                                         overflow: 'hidden',
//                                                         textOverflow: 'ellipsis',
//                                                         cursor: 'pointer'
//                                                     }}
//                                                         title={item.remarks}
//                                                         onClick={() => alert(`Remarks: ${item.remarks}`)}
//                                                     >
//                                                         {item.remarks}
//                                                     </div>
//                                                 ) : "-"}
//                                             </td>
//                                             <td style={tableCellStyle}>
//                                                 <span style={getPaymentModeStyle(item.pytMode)}>
//                                                     {item.pytMode || "FT"}
//                                                 </span>
//                                             </td>
//                                             <td style={tableCellStyle}>
//                                                 {item.paymentStatus !== "PAID" ? (
//                                                     <button
//                                                         onClick={() => handleStatusUpdateClick(item)}
//                                                         style={{
//                                                             padding: "4px 8px",
//                                                             backgroundColor: "#2196F3",
//                                                             color: "white",
//                                                             border: "none",
//                                                             borderRadius: "4px",
//                                                             cursor: "pointer",
//                                                             fontSize: "12px"
//                                                         }}
//                                                     >
//                                                         Update Status
//                                                     </button>
//                                                 ) : (
//                                                     <span style={{
//                                                         color: "#4CAF50",
//                                                         fontSize: "12px",
//                                                         fontWeight: "bold"
//                                                     }}>
//                                                         Completed
//                                                     </span>
//                                                 )}
//                                             </td>
//                                         </tr>
//                                     ))
//                                 ) : (
//                                     <tr>
//                                         <td colSpan="18" style={{
//                                             fontStyle: "italic",
//                                             textAlign: "center",
//                                             padding: "20px",
//                                             color: "#888"
//                                         }}>
//                                             {settlements.length === 0
//                                                 ? "Loading data or no settlements found."
//                                                 : (searchQuery.trim() || selectedStatusFilter || selectedDate)
//                                                     ? "No settlements found with the specified filters."
//                                                     : "No settlements match the current filters."}
//                                         </td>
//                                     </tr>
//                                 )}
//                             </tbody>
//                         </table>
//                     </div>

//                     {/* Status Update Modal */}
//                     {showStatusModal && selectedSettlement && (
//                         <div style={modalOverlayStyle} onClick={(e) => e.target === e.currentTarget && setShowStatusModal(false)}>
//                             <div style={modalContentStyle}>
//                                 <div style={modalHeaderStyle}>
//                                     <h3 style={{ margin: 0, color: '#333' }}>
//                                         Update Settlement Status
//                                     </h3>
//                                     <button
//                                         onClick={() => setShowStatusModal(false)}
//                                         style={{
//                                             background: 'transparent',
//                                             border: 'none',
//                                             fontSize: '20px',
//                                             cursor: 'pointer',
//                                             color: '#666',
//                                             fontWeight: 'bold'
//                                         }}
//                                     >
//                                         ✕
//                                     </button>
//                                 </div>

//                                 <div style={modalBodyStyle}>
//                                     <div style={{ marginBottom: '15px' }}>
//                                         <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
//                                             Settlement ID
//                                         </label>
//                                         <input
//                                             type="text"
//                                             value={selectedSettlement.settlementId}
//                                             readOnly
//                                             style={{
//                                                 width: '100%',
//                                                 padding: '8px',
//                                                 border: '1px solid #ddd',
//                                                 borderRadius: '4px',
//                                                 backgroundColor: '#f5f5f5',
//                                                 cursor: 'not-allowed'
//                                             }}
//                                         />
//                                     </div>

//                                     <div style={{ marginBottom: '15px' }}>
//                                         <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
//                                             Vendor ID
//                                         </label>
//                                         <input
//                                             type="text"
//                                             value={selectedSettlement.vendorId}
//                                             readOnly
//                                             style={{
//                                                 width: '100%',
//                                                 padding: '8px',
//                                                 border: '1px solid #ddd',
//                                                 borderRadius: '4px',
//                                                 backgroundColor: '#f5f5f5',
//                                                 cursor: 'not-allowed'
//                                             }}
//                                         />
//                                     </div>

//                                     <div style={{ marginBottom: '15px' }}>
//                                         <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
//                                             Vendor Name
//                                         </label>
//                                         <input
//                                             type="text"
//                                             value={selectedSettlement.holderName || "-"}
//                                             readOnly
//                                             style={{
//                                                 width: '100%',
//                                                 padding: '8px',
//                                                 border: '1px solid #ddd',
//                                                 borderRadius: '4px',
//                                                 backgroundColor: '#f5f5f5',
//                                                 cursor: 'not-allowed'
//                                             }}
//                                         />
//                                     </div>

//                                     <div style={{ marginBottom: '15px' }}>
//                                         <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
//                                             Current Status
//                                         </label>
//                                         <div style={getStatusStyle(selectedSettlement.paymentStatus)}>
//                                             {selectedSettlement.paymentStatus}
//                                         </div>
//                                     </div>

//                                     <div style={{ marginBottom: '15px' }}>
//                                         <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
//                                             Payment Mode
//                                         </label>
//                                         <select
//                                             value={pytMode}
//                                             onChange={(e) => setPytMode(e.target.value)}
//                                             style={{
//                                                 width: '100%',
//                                                 padding: '8px',
//                                                 border: '1px solid #ddd',
//                                                 borderRadius: '4px'
//                                             }}
//                                         >
//                                             <option value="FT">FT (Fund Transfer)</option>
//                                             <option value="NEFT">NEFT</option>
//                                             <option value="RTGS">RTGS</option>
//                                             <option value="IMPS">IMPS</option>
//                                         </select>
//                                     </div>

//                                     <div style={{ marginBottom: '15px' }}>
//                                         <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
//                                             New Status *
//                                         </label>
//                                         <select
//                                             value={newStatus}
//                                             onChange={(e) => setNewStatus(e.target.value)}
//                                             style={{
//                                                 width: '100%',
//                                                 padding: '8px',
//                                                 border: '1px solid #ddd',
//                                                 borderRadius: '4px'
//                                             }}
//                                             required
//                                         >
//                                             <option value="">Select Status</option>
//                                             <option value="PENDING">PENDING</option>
//                                             <option value="PAID">PAID</option>
//                                         </select>
//                                     </div>

//                                     <div style={{ marginBottom: '20px' }}>
//                                         <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
//                                             Remarks *
//                                         </label>
//                                         <textarea
//                                             value={remarks}
//                                             onChange={(e) => setRemarks(e.target.value)}
//                                             placeholder="Enter remarks for status update (required)"
//                                             rows="3"
//                                             style={{
//                                                 width: '100%',
//                                                 padding: '8px',
//                                                 border: '1px solid #ddd',
//                                                 borderRadius: '4px',
//                                                 resize: 'vertical'
//                                             }}
//                                             required
//                                         />
//                                         <small style={{ color: '#666', fontSize: '12px', marginTop: '5px', display: 'block' }}>
//                                             Please provide a reason for the status change
//                                         </small>
//                                     </div>

//                                     <div style={{ display: 'flex', gap: '10px' }}>
//                                         <button
//                                             onClick={handleUpdateStatus}
//                                             style={{
//                                                 flex: 1,
//                                                 padding: '10px',
//                                                 backgroundColor: '#4CAF50',
//                                                 color: 'white',
//                                                 border: 'none',
//                                                 borderRadius: '4px',
//                                                 cursor: 'pointer',
//                                                 fontWeight: 'bold'
//                                             }}
//                                         >
//                                             Update Status
//                                         </button>
//                                         <button
//                                             onClick={() => setShowStatusModal(false)}
//                                             style={{
//                                                 flex: 1,
//                                                 padding: '10px',
//                                                 backgroundColor: '#f5f5f5',
//                                                 color: '#333',
//                                                 border: '1px solid #ddd',
//                                                 borderRadius: '4px',
//                                                 cursor: 'pointer',
//                                                 fontWeight: 'bold'
//                                             }}
//                                         >
//                                             Cancel
//                                         </button>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Foodsettlementpage;




// import React, { useState, useEffect, useMemo } from "react";
// import axios from "axios";
// import { useLoader } from '../../../../context/LoaderProvider.jsx';
// import {
//     getAllSettlementsAPI,
//     updateSettlementStatusAPI,
// } from "../../../Servicefile/AccountManagementService.jsx";

// // ============================================
// // PREMIUM ICONS COMPONENT
// // ============================================
// const Icons = {
//     Search: () => (
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
//         </svg>
//     ),
//     Export: () => (
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
//             <polyline points="7 10 12 15 17 10"/>
//             <line x1="12" y1="15" x2="12" y2="3"/>
//         </svg>
//     ),
//     Clear: () => (
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
//         </svg>
//     ),
//     Filter: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <polygon points="22 3 2 3 10 13 10 21 14 18 14 13 22 3"/>
//         </svg>
//     ),
//     Calendar: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
//             <line x1="16" y1="2" x2="16" y2="6"/>
//             <line x1="8" y1="2" x2="8" y2="6"/>
//             <line x1="3" y1="10" x2="21" y2="10"/>
//         </svg>
//     ),
//     Money: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0b5e42" strokeWidth="2">
//             <circle cx="12" cy="12" r="10"/>
//             <path d="M8 12h8"/>
//             <path d="M12 8v8"/>
//         </svg>
//     ),
//     Vendor: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
//             <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
//         </svg>
//     ),
//     Bank: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <rect x="2" y="6" width="20" height="14" rx="2"/>
//             <path d="M2 10h20"/>
//             <path d="M8 14v4"/>
//             <path d="M12 14v4"/>
//             <path d="M16 14v4"/>
//         </svg>
//     ),
//     Status: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <circle cx="12" cy="12" r="10"/>
//             <polyline points="12 6 12 12 16 14"/>
//         </svg>
//     ),
//     NoData: () => (
//         <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
//             <rect x="2" y="3" width="20" height="18" rx="2"/>
//             <line x1="8" y1="21" x2="16" y2="21"/>
//             <line x1="12" y1="17" x2="12" y2="21"/>
//             <path d="M8 7h8M8 11h6M8 15h4"/>
//         </svg>
//     ),
//     Close: () => (
//         <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <line x1="18" y1="6" x2="6" y2="18"/>
//             <line x1="6" y1="6" x2="18" y2="18"/>
//         </svg>
//     ),
//     Edit: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
//             <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
//         </svg>
//     ),
//     Refresh: () => (
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <path d="M23 4v6h-6M1 20v-6h6"/>
//             <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
//         </svg>
//     ),
//     Settlement: () => (
//         <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgb(230 109 51)" strokeWidth="2">
//             <circle cx="12" cy="12" r="10"/>
//             <path d="M8 12h8"/>
//             <path d="M12 8v8"/>
//         </svg>
//     )
// };

// // ============================================
// // PREMIUM STYLES
// // ============================================
// const styles = {
//     settlementContainer: {
//         padding: '1px 5px',


//         // minHeight: '500px',

//         width: '100%',
//         maxWidth: '72%',
//         overflowX: 'hidden'
//     },
//     settlementHeader: {
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '0 0 16px 0',
//         borderBottom: '2px solid #e9ecef',
//         flexWrap: 'wrap',
//         gap: '12px'
//     },
//     settlementTitle: {
//         fontSize: '20px',
//         fontWeight: '600',
//         color: '#2d3748',
//         letterSpacing: '-0.3px',
//         display: 'flex',
//         alignItems: 'center',
//         gap: '10px'
//     },
//     settlementTitleBadge: {
//         background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
//         color: 'white',
//         fontSize: '12px',
//         fontWeight: '500',
//         padding: '2px 12px',
//         borderRadius: '12px',
//         letterSpacing: '0.3px'
//     },
//     settlementStatsGrid: {
//         display: 'grid',
//         gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
//         gap: '14px',
//         marginBottom: '16px',
//         padding: '18px',
//         background: 'white',
//         borderRadius: '14px',
//         border: '1px solid #edf2f7',
//         boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
//     },
//     settlementStatCard: {
//         textAlign: 'center',
//         padding: '8px 4px',
//         borderRadius: '10px',
//         transition: 'all 0.3s ease',
//         cursor: 'default'
//     },
//     settlementStatCardHover: {
//         transform: 'translateY(-2px)',
//         boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
//     },
//     settlementStatValue: {
//         fontSize: '26px',
//         fontWeight: '700',
//         color: '#2d3748',
//         lineHeight: '1.2'
//     },
//     settlementStatLabel: {
//         fontSize: '12px',
//         color: '#718096',
//         fontWeight: '500',
//         textTransform: 'uppercase',
//         letterSpacing: '0.4px',
//         marginTop: '4px'
//     },
//     settlementFilters: {
//         display: 'flex',
//         flexWrap: 'nowrap',
//         alignItems: 'center',
//         gap: '10px',
//         padding: '12px 0',
//         borderBottom: '1px solid #edf2f7',
//         marginBottom: '16px'
//     },
//     settlementSearchGroup: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '8px',
//         flex: '1 1 auto',
//         minWidth: '280px'
//     },
//     settlementSelect: {
//         padding: '8px 12px',
//         border: '2px solid #e2e8f0',
//         borderRadius: '10px',
//         background: 'white',
//         fontSize: '13px',
//         fontWeight: '500',
//         color: '#2d3748',
//         outline: 'none',
//         transition: 'all 0.3s ease',
//         height: '42px',
//         minWidth: '140px',
//         cursor: 'pointer'
//     },
//     settlementSearchInput: {
//         flex: '1',
//         padding: '8px 14px 8px 38px',
//         border: '2px solid #e2e8f0',
//         borderRadius: '10px',
//         fontSize: '13px',
//         color: '#2d3748',
//         outline: 'none',
//         transition: 'all 0.3s ease',
//         height: '42px',
//         background: 'white',
//         minWidth: '180px'
//     },
//     settlementDateInput: {
//         padding: '8px 14px',
//         border: '2px solid #e2e8f0',
//         borderRadius: '10px',
//         fontSize: '13px',
//         color: '#2d3748',
//         outline: 'none',
//         transition: 'all 0.3s ease',
//         height: '42px',
//         background: 'white',
//         minWidth: '150px'
//     },
//     settlementButton: {
//         padding: '8px 18px',
//         borderRadius: '10px',
//         border: 'none',
//         fontWeight: '600',
//         fontSize: '13px',
//         display: 'flex',
//         alignItems: 'center',
//         gap: '6px',
//         cursor: 'pointer',
//         transition: 'all 0.3s ease',
//         height: '42px',
//         whiteSpace: 'nowrap'
//     },
//     settlementButtonPrimary: {
//         background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
//         color: 'white',
//         boxShadow: '0 4px 15px rgba(230, 109, 51, 0.3)'
//     },
//     settlementButtonSecondary: {
//         background: '#e2e8f0',
//         color: '#4a5568'
//     },
//     settlementButtonExport: {
//         background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
//         color: 'white',
//         boxShadow: '0 4px 15px rgba(40, 167, 69, 0.3)'
//     },
//     settlementTableWrapper: {
//         borderRadius: '12px',
//         border: '1px solid #edf2f7',
//         background: 'white',
//         overflow: 'auto',
//         maxHeight: '60vh',
//         position: 'relative',
//         width: '100%',
//         maxWidth: '100%'
//     },
//     settlementTable: {
//         width: '100%',
//         fontSize: '13px',
//         borderCollapse: 'collapse',
//         minWidth: '1700px'
//     },
//     settlementTableHead: {
//         position: 'sticky',
//         top: 0,
//         zIndex: 10
//     },
//     settlementTableHeader: {
//         padding: '10px 12px',
//         textAlign: 'center',
//         fontWeight: '600',
//         fontSize: '11px',
//         textTransform: 'uppercase',
//         letterSpacing: '0.5px',
//         color: 'white',
//         background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
//         borderBottom: '2px solid #d45a1a',
//         whiteSpace: 'nowrap'
//     },
//     settlementTableCell: {
//         padding: '10px 12px',
//         borderBottom: '1px solid #f1f5f9',
//         color: '#2d3748',
//         fontSize: '13px',
//         textAlign: 'center',
//         verticalAlign: 'middle'
//     },
//     settlementBadge: {
//         display: 'inline-flex',
//         alignItems: 'center',
//         gap: '4px',
//         padding: '3px 12px',
//         borderRadius: '20px',
//         fontSize: '11px',
//         fontWeight: '600',
//         letterSpacing: '0.3px'
//     },
//     settlementBadgePaid: {
//         background: '#c6f6d5',
//         color: '#276749'
//     },
//     settlementBadgePending: {
//         background: '#fefcbf',
//         color: '#975a16'
//     },
//     settlementBadgeDefault: {
//         background: '#e2e8f0',
//         color: '#4a5568'
//     },
//     settlementEmptyState: {
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         justifyContent: 'center',
//         padding: '60px 20px',
//         color: '#a0aec0'
//     },
//     settlementEmptyStateText: {
//         marginTop: '16px',
//         fontSize: '16px',
//         fontWeight: '500',
//         color: '#4a5568'
//     },
//     settlementEmptyStateSubtext: {
//         fontSize: '13px',
//         color: '#a0aec0',
//         marginTop: '4px'
//     },
//     settlementModalOverlay: {
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         backgroundColor: 'rgba(0, 0, 0, 0.6)',
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         zIndex: 9999,
//         backdropFilter: 'blur(4px)',
//         padding: '20px'
//     },
//     settlementModal: {
//         background: 'white',
//         borderRadius: '16px',
//         padding: '28px',
//         width: '560px',
//         maxWidth: '95%',
//         maxHeight: '85vh',
//         scrollbarWidth: 'none',
//         overflowY: 'auto',
//         boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
//         animation: 'settlementSlideUp 0.3s ease'
//     },
//     settlementModalHeader: {
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         paddingBottom: '16px',
//         borderBottom: '2px solid #f0f0f0',
//         marginBottom: '20px'
//     },
//     settlementModalTitle: {
//         fontSize: '20px',
//         fontWeight: '700',
//         color: '#1a1a2e',
//         margin: 0,
//         display: 'flex',
//         alignItems: 'center',
//         gap: '10px'
//     },
//     settlementModalClose: {
//         background: 'none',
//         border: 'none',
//         cursor: 'pointer',
//         color: '#a0aec0',
//         transition: 'all 0.3s ease',
//         padding: '4px'
//     },
//     settlementModalBody: {
//         padding: '0 0 4px 0'
//     },

//     // NEW: Two-column grid layout for form fields
//     settlementFormRow: {
//         display: 'grid',
//         gridTemplateColumns: '1fr 1fr',
//         gap: '16px',
//         marginBottom: '16px'
//     },

//     settlementFormGroup: {
//         marginBottom: '16px'
//     },

//     // Full width form group (spans both columns)
//     settlementFormGroupFull: {
//         marginBottom: '16px',
//         gridColumn: '1 / -1'
//     },

//     settlementLabel: {
//         display: 'block',
//         marginBottom: '6px',
//         fontSize: '13px',
//         fontWeight: '600',
//         color: '#4a5568'
//     },
//     settlementReadOnlyInput: {
//         width: '100%',
//         padding: '10px 14px',
//         borderRadius: '8px',
//         border: '2px solid #edf2f7',
//         fontSize: '13px',
//         color: '#2d3748',
//         outline: 'none',
//         background: '#f7fafc',
//         cursor: 'not-allowed',
//         boxSizing: 'border-box'
//     },
//     settlementSelect: {
//         width: '100%',
//         padding: '10px 14px',
//         borderRadius: '8px',
//         border: '2px solid #e2e8f0',
//         fontSize: '13px',
//         fontWeight: '500',
//         color: '#2d3748',
//         outline: 'none',
//         transition: 'all 0.3s ease',
//         boxSizing: 'border-box',
//         background: 'white',
//         cursor: 'pointer'
//     },
//     settlementTextarea: {
//         width: '100%',
//         padding: '10px 14px',
//         borderRadius: '8px',
//         border: '2px solid #e2e8f0',
//         fontSize: '13px',
//         outline: 'none',
//         transition: 'all 0.3s ease',
//         resize: 'vertical',
//         boxSizing: 'border-box',
//         fontFamily: 'inherit'
//     },
//     settlementModalFooter: {
//         display: 'flex',
//         gap: '10px',
//         paddingTop: '16px',
//         borderTop: '2px solid #f0f0f0',
//         marginTop: '4px'
//     },
//     settlementAmount: {
//         fontWeight: '600',
//         color: '#0b5e42'
//     },
//     settlementRemarksCell: {
//         maxWidth: '150px',
//         whiteSpace: 'nowrap',
//         overflow: 'hidden',
//         textOverflow: 'ellipsis',
//         cursor: 'pointer',
//         color: '#4a5568'
//     },
//     settlementPaymentMode: {
//         display: 'inline-block',
//         padding: '2px 10px',
//         borderRadius: '4px',
//         fontSize: '11px',
//         fontWeight: '600'
//     },
//     settlementPaymentModeFT: {
//         background: '#bee3f8',
//         color: '#2a4365'
//     },
//     settlementPaymentModeNEFT: {
//         background: '#c6f6d5',
//         color: '#276749'
//     },
//     settlementPaymentModeRTGS: {
//         background: '#e9d8fd',
//         color: '#553c9a'
//     },
//     settlementPaymentModeIMPS: {
//         background: '#fefcbf',
//         color: '#975a16'
//     },
//     settlementPaymentModeDefault: {
//         background: '#e2e8f0',
//         color: '#4a5568'
//     }
// }

// const Foodsettlementpage = () => {
//     // Filter states
//     const [searchType, setSearchType] = useState("vendorId");
//     const [searchQuery, setSearchQuery] = useState("");
//     const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
//     const [selectedDate, setSelectedDate] = useState("");

//     const searchOptions = [
//         { value: "vendorId", label: "Vendor ID" },
//         { value: "holderName", label: "Vendor Name" },
//         { value: "accountNumber", label: "Account Number" },
//         { value: "ifscCode", label: "IFSC Code" }
//     ];

//     const [invoiceData, setInvoiceData] = useState(null);
//     const [settlements, setSettlements] = useState([]);
//     const [filteredSettlements, setFilteredSettlements] = useState([]);
//     const [showStatusModal, setShowStatusModal] = useState(false);
//     const [selectedSettlement, setSelectedSettlement] = useState(null);
//     const [newStatus, setNewStatus] = useState("");
//     const [remarks, setRemarks] = useState("");
//     const [pytMode, setPytMode] = useState("FT");

//     const { showLoader, hideLoader } = useLoader();

//     useEffect(() => {
//         fetchSettlements();
//     }, []);

//     const fetchSettlements = async () => {
//         try {
//             showLoader();
//             const res = await getAllSettlementsAPI();
//             const data = res.settlements || res;
//             const dataWithSno = Array.isArray(data)
//                 ? data.map((item, index) => ({
//                     ...item,
//                     sno: index + 1,
//                 }))
//                 : [];
//             setSettlements(dataWithSno);
//             setFilteredSettlements(dataWithSno);
//         } catch (err) {
//             console.error("Error fetching settlements:", err);
//         } finally {
//             hideLoader();
//         }
//     };

//     const getPlaceholderText = () => {
//         switch (searchType) {
//             case "vendorId": return "Search by Vendor ID...";
//             case "holderName": return "Search by Vendor Name...";
//             case "accountNumber": return "Search by Account Number...";
//             case "ifscCode": return "Search by IFSC Code...";
//             default: return "Search...";
//         }
//     };

//     const searchFilteredData = useMemo(() => {
//         if (!searchQuery.trim() && !selectedStatusFilter && !selectedDate) {
//             return settlements;
//         }
//         const query = searchQuery.toLowerCase().trim();
//         return settlements.filter(item => {
//             let searchMatch = true;
//             if (searchQuery.trim()) {
//                 const fieldValue = item[searchType];
//                 searchMatch = fieldValue && fieldValue.toString().toLowerCase().includes(query);
//             }
//             let statusMatch = true;
//             if (selectedStatusFilter) {
//                 statusMatch = item.paymentStatus === selectedStatusFilter;
//             }
//             let dateMatch = true;
//             if (selectedDate) {
//                 const settlementDate = item.settlementDate || "";
//                 dateMatch = settlementDate === selectedDate;
//             }
//             return searchMatch && statusMatch && dateMatch;
//         });
//     }, [settlements, searchType, searchQuery, selectedStatusFilter, selectedDate]);

//     useEffect(() => {
//         setFilteredSettlements(searchFilteredData);
//     }, [searchFilteredData]);

//     const clearAllFilters = () => {
//         setSearchQuery("");
//         setSelectedStatusFilter("");
//         setSelectedDate("");
//     };

//     const uniqueStatuses = useMemo(() => {
//         const statuses = settlements.map(item => item.paymentStatus).filter(Boolean);
//         return [...new Set(statuses)].sort();
//     }, [settlements]);

//     const handleStatusUpdateClick = (settlement) => {
//         setSelectedSettlement(settlement);
//         setNewStatus(settlement.paymentStatus);
//         setRemarks(settlement.remarks || "");
//         setPytMode(settlement.pytMode || "FT");
//         setShowStatusModal(true);
//     };

//     const handleUpdateStatus = async () => {
//         if (!selectedSettlement || !newStatus) {
//             alert("Please select a status");
//             return;
//         }
//         if (!remarks.trim()) {
//             alert("Please enter remarks for the status update");
//             return;
//         }

//         const settlementId = selectedSettlement.settlementId;
//         const updateData = {
//             settlementId: settlementId,
//             vendorId: selectedSettlement.vendorId,
//             totalCgst: selectedSettlement.totalCgst || 0,
//             totalSgst: selectedSettlement.totalSgst || 0,
//             totalGrandTotal: selectedSettlement.totalGrandTotal || 0,
//             totalServiceCharges: selectedSettlement.totalServiceCharges || 0,
//             totalPlatformCharges: selectedSettlement.totalPlatformCharges || 0,
//             totalOnlinePayment: selectedSettlement.totalOnlinePayment || 0,
//             totalAmountBeforeTds: selectedSettlement.totalAmountBeforeTds || 0,
//             tdsAmount: selectedSettlement.tdsAmount || 0,
//             amountAfterTds: selectedSettlement.amountAfterTds || 0,
//             amountAfterCash: selectedSettlement.amountAfterCash || 0,
//             finalAmount: selectedSettlement.finalAmount || 0,
//             totalCash: selectedSettlement.totalCash || 0,
//             description: selectedSettlement.description || "",
//             fromDate: selectedSettlement.fromDate || new Date().toISOString(),
//             toDate: selectedSettlement.toDate || new Date().toISOString(),
//             totalVendorPlatformCharges: selectedSettlement.totalVendorPlatformCharges || 0,
//             totalVendorPlatformChargesGst: selectedSettlement.totalVendorPlatformChargesGst || 0,
//             holderName: selectedSettlement.holderName || "",
//             accountNumber: selectedSettlement.accountNumber || "",
//             ifscCode: selectedSettlement.ifscCode || "",
//             settlementDate: selectedSettlement.settlementDate || new Date().toISOString().split("T")[0],
//             paymentStatus: newStatus,
//             superadminAccNo: selectedSettlement.superadminAccNo || "",
//             pytMode: pytMode,
//             remarks: remarks,
//             totalWalletPayment: selectedSettlement.totalWalletPayment || 0,
//             commission: selectedSettlement.commission || 0,
//         };

//         try {
//             showLoader();
//             await updateSettlementStatusAPI(settlementId, updateData);
//             alert("Status updated successfully!");
//             await fetchSettlements();
//             setShowStatusModal(false);
//             setSelectedSettlement(null);
//             setNewStatus("");
//             setRemarks("");
//             setPytMode("FT");
//         } catch (err) {
//             console.error("Error updating status:", err);
//             alert(`Failed to update status: ${err.response?.data?.message || err.message}`);
//         } finally {
//             hideLoader();
//         }
//     };

//     const handleExport = () => {
//         const exportData = filteredSettlements.length > 0 ? filteredSettlements : settlements;
//         if (exportData.length === 0) {
//             alert("There is no data to export.");
//             return;
//         }

//         const escapeCsvField = (field) => {
//             const str = String(field ?? '');
//             if (str.includes(',') || str.includes('"') || str.includes('\n')) {
//                 return `"${str.replace(/"/g, '""')}"`;
//             }
//             return str;
//         };

//         const headers = [
//             "S.NO", "Vendor ID", "Vendor Name", "Total Sales", "Service Charges",
//             "Commission Charges", "To Settle", "Total Cash", "From Date", "To Date",
//             "Admin Account", "Vendor Account", "IFSC Code", "Settlement Date",
//             "Status", "Payment Mode", "Remarks"
//         ];

//         const csvRows = exportData.map((item) => [
//             item.sno || '',
//             item.vendorId || '',
//             item.holderName || '',
//             item.totalAmountBeforeTds || 0,
//             item.tdsAmount || 0,
//             item.commission || 0,
//             item.finalAmount || 0,
//             item.totalCash || 0,
//             formatDate(item.fromDate),
//             formatDate(item.toDate),
//             item.superadminAccNo || '',
//             item.accountNumber || '',
//             item.ifscCode || '',
//             item.settlementDate || '',
//             item.paymentStatus || '',
//             item.pytMode || 'FT',
//             item.remarks || ''
//         ]);

//         const csvString = [
//             headers.map(escapeCsvField).join(','),
//             ...csvRows.map(row => row.map(escapeCsvField).join(','))
//         ].join('\r\n');

//         const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
//         const url = URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         link.setAttribute("href", url);
//         link.setAttribute("download", `settlements_${new Date().toISOString().split('T')[0]}.csv`);
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         URL.revokeObjectURL(url);
//     };

//     const getStatusBadge = (status) => {
//         if (!status) return styles.settlementBadgeDefault;
//         if (status === "PAID") return styles.settlementBadgePaid;
//         if (status === "PENDING") return styles.settlementBadgePending;
//         return styles.settlementBadgeDefault;
//     };

//     const getPaymentModeStyle = (mode) => {
//         switch (mode) {
//             case "FT": return styles.settlementPaymentModeFT;
//             case "NEFT": return styles.settlementPaymentModeNEFT;
//             case "RTGS": return styles.settlementPaymentModeRTGS;
//             case "IMPS": return styles.settlementPaymentModeIMPS;
//             default: return styles.settlementPaymentModeDefault;
//         }
//     };

//     const formatDate = (dateString) => {
//         if (!dateString) return "-";
//         const date = new Date(dateString);
//         return date.toISOString().split("T")[0];
//     };

//     // Calculate stats
//     const totalSettlements = settlements.length;
//     const totalAmount = settlements.reduce((sum, item) => sum + (item.finalAmount || 0), 0);
//     const paidCount = settlements.filter(item => item.paymentStatus === "PAID").length;
//     const pendingCount = settlements.filter(item => item.paymentStatus === "PENDING").length;

//     return (
//         <div className="settlement-wrapper" style={styles.settlementContainer}>

//             {/* Filters */}
//             <div style={styles.settlementFilters}>
//                 <div style={styles.settlementSearchGroup}>
//                     <div style={{ position: 'relative', flex: 1 }}>

//                         <input
//                             type="text"
//                             placeholder={getPlaceholderText()}
//                             value={searchQuery}
//                             onChange={(e) => setSearchQuery(e.target.value)}
//                             style={{
//                                 ...styles.settlementSearchInput,
//                                 borderColor: searchQuery ? '#e66d33' : '#e2e8f0'
//                             }}
//                             onFocus={(e) => {
//                                 e.target.style.borderColor = '#e66d33';
//                                 e.target.style.boxShadow = '0 0 0 3px rgba(230, 109, 51, 0.1)';
//                             }}
//                             onBlur={(e) => {
//                                 e.target.style.borderColor = '#e2e8f0';
//                                 e.target.style.boxShadow = 'none';
//                             }}
//                         />
//                     </div>
//                 </div>

//                 <select
//                     value={searchType}
//                     onChange={(e) => setSearchType(e.target.value)}
//                     style={styles.settlementSelect}
//                 >
//                     {searchOptions.map(option => (
//                         <option key={option.value} value={option.value}>
//                             {option.label}
//                         </option>
//                     ))}
//                 </select>

//                 <select
//                     value={selectedStatusFilter}
//                     onChange={(e) => setSelectedStatusFilter(e.target.value)}
//                     style={{ ...styles.settlementSelect, minWidth: '130px' }}
//                 >
//                     <option value="">All Status</option>
//                     {uniqueStatuses.map(status => (
//                         <option key={status} value={status}>{status}</option>
//                     ))}
//                 </select>

//                 <input
//                     type="date"
//                     value={selectedDate}
//                     onChange={(e) => setSelectedDate(e.target.value)}
//                     style={styles.settlementDateInput}
//                 />

//                 <button onClick={clearAllFilters} style={{ ...styles.settlementButton, ...styles.settlementButtonSecondary }}>
//                     <Icons.Clear /> Clear
//                 </button>

//                 <button onClick={handleExport} style={{ ...styles.settlementButton, ...styles.settlementButtonExport }}>
//                     <Icons.Export /> Export
//                 </button>
//             </div>

//             {/* Table */}
//             <div style={styles.settlementTableWrapper}>
//                 <table style={styles.settlementTable}>
//                     <thead style={styles.settlementTableHead}>
//                         <tr>
//                             <th style={{ ...styles.settlementTableHeader, width: '4%' }}>#</th>
//                             <th style={{ ...styles.settlementTableHeader, width: '6%' }}>Vendor ID</th>
//                             <th style={{ ...styles.settlementTableHeader, width: '8%' }}>Total Sales</th>
//                             <th style={{ ...styles.settlementTableHeader, width: '8%' }}>Service Charges</th>
//                             <th style={{ ...styles.settlementTableHeader, width: '8%' }}>Commission</th>
//                             <th style={{ ...styles.settlementTableHeader, width: '8%' }}>To Settle</th>
//                             <th style={{ ...styles.settlementTableHeader, width: '6%' }}>Cash</th>
//                             <th style={{ ...styles.settlementTableHeader, width: '8%' }}>From</th>
//                             <th style={{ ...styles.settlementTableHeader, width: '8%' }}>To</th>
//                             <th style={{ ...styles.settlementTableHeader, width: '6%' }}>Admin Acc</th>
//                             <th style={{ ...styles.settlementTableHeader, width: '8%' }}>Vendor</th>
//                             <th style={{ ...styles.settlementTableHeader, width: '8%' }}>Account</th>
//                             <th style={{ ...styles.settlementTableHeader, width: '6%' }}>IFSC</th>
//                             <th style={{ ...styles.settlementTableHeader, width: '8%' }}>Settle Date</th>
//                             <th style={{ ...styles.settlementTableHeader, width: '6%', textAlign: 'center' }}>Status</th>
//                             <th style={{ ...styles.settlementTableHeader, width: '8%' }}>Remarks</th>
//                             <th style={{ ...styles.settlementTableHeader, width: '6%', textAlign: 'center' }}>Mode</th>
//                             <th style={{ ...styles.settlementTableHeader, width: '6%', textAlign: 'center' }}>Action</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {filteredSettlements.length > 0 ? (
//                             filteredSettlements.map((item, index) => (
//                                 <tr
//                                     key={item.settlementId || item.vendorId || index}
//                                     style={{
//                                         backgroundColor: index % 2 === 0 ? '#ffffff' : '#fafbfc',
//                                         transition: 'background 0.15s ease'
//                                     }}
//                                     onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4ff'}
//                                     onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#fafbfc'}
//                                 >
//                                     <td style={{ ...styles.settlementTableCell, color: '#a0aec0' }}>{item.sno || '-'}</td>
//                                     <td style={{ ...styles.settlementTableCell, fontFamily: 'monospace', fontSize: '12px' }}>{item.vendorId}</td>
//                                     <td style={{ ...styles.settlementTableCell, ...styles.settlementAmount }}>₹{item.totalAmountBeforeTds}</td>
//                                     <td style={styles.settlementTableCell}>₹{item.tdsAmount || 0}</td>
//                                     <td style={styles.settlementTableCell}>₹{item.commission || 0}</td>
//                                     <td style={{ ...styles.settlementTableCell, ...styles.settlementAmount }}>₹{item.finalAmount}</td>
//                                     <td style={styles.settlementTableCell}>₹{item.totalCash}</td>
//                                     <td style={styles.settlementTableCell}>{formatDate(item.fromDate)}</td>
//                                     <td style={styles.settlementTableCell}>{formatDate(item.toDate)}</td>
//                                     <td style={{ ...styles.settlementTableCell, fontFamily: 'monospace', fontSize: '12px' }}>{item.superadminAccNo}</td>
//                                     <td style={{ ...styles.settlementTableCell, fontWeight: '500' }}>{item.holderName}</td>
//                                     <td style={{ ...styles.settlementTableCell, fontFamily: 'monospace', fontSize: '12px' }}>{item.accountNumber}</td>
//                                     <td style={{ ...styles.settlementTableCell, fontFamily: 'monospace', fontSize: '12px' }}>{item.ifscCode}</td>
//                                     <td style={styles.settlementTableCell}>{item.settlementDate}</td>
//                                     <td style={styles.settlementTableCell}>
//                                         <span style={{ ...styles.settlementBadge, ...getStatusBadge(item.paymentStatus) }}>
//                                             {item.paymentStatus}
//                                         </span>
//                                     </td>
//                                     <td style={styles.settlementTableCell}>
//                                         {item.remarks ? (
//                                             <div style={styles.settlementRemarksCell} title={item.remarks}>
//                                                 {item.remarks}
//                                             </div>
//                                         ) : "-"}
//                                     </td>
//                                     <td style={styles.settlementTableCell}>
//                                         <span style={{ ...styles.settlementPaymentMode, ...getPaymentModeStyle(item.pytMode) }}>
//                                             {item.pytMode || "FT"}
//                                         </span>
//                                     </td>
//                                     <td style={styles.settlementTableCell}>
//                                         {item.paymentStatus !== "PAID" ? (
//                                             <button
//                                                 onClick={() => handleStatusUpdateClick(item)}
//                                                 style={{
//                                                     ...styles.settlementButton,
//                                                     ...styles.settlementButtonPrimary,
//                                                     padding: '4px 12px',
//                                                     height: '32px',
//                                                     fontSize: '12px'
//                                                 }}
//                                             >
//                                                 <Icons.Edit /> Update
//                                             </button>
//                                         ) : (
//                                             <span style={{ color: '#48bb78', fontWeight: '600', fontSize: '12px' }}>
//                                                 ✓ Completed
//                                             </span>
//                                         )}
//                                     </td>
//                                 </tr>
//                             ))
//                         ) : (
//                             <tr>
//                                 <td colSpan="18" style={{ padding: 0 }}>
//                                     <div style={styles.settlementEmptyState}>
//                                         <Icons.NoData />
//                                         <div style={styles.settlementEmptyStateText}>
//                                             {settlements.length === 0 ? 'Loading settlements...' : 'No settlements found'}
//                                         </div>
//                                         <div style={styles.settlementEmptyStateSubtext}>
//                                             {settlements.length === 0
//                                                 ? 'Please wait while we fetch the data'
//                                                 : (searchQuery.trim() || selectedStatusFilter || selectedDate)
//                                                     ? 'Try adjusting your filters to see more results'
//                                                     : 'No settlements are available'}
//                                         </div>
//                                     </div>
//                                 </td>
//                             </tr>
//                         )}
//                     </tbody>
//                 </table>
//             </div>


// {showStatusModal && selectedSettlement && (
//     <div style={styles.settlementModalOverlay} onClick={() => setShowStatusModal(false)}>
//         <div style={styles.settlementModal} onClick={(e) => e.stopPropagation()}>
//             <div style={styles.settlementModalHeader}>
//                 <h3 style={styles.settlementModalTitle}>
//                     <Icons.Edit style={{ color: '#e66d33' }} /> Update Status
//                 </h3>
//                 <button style={styles.settlementModalClose} onClick={() => setShowStatusModal(false)}>
//                     <Icons.Close />
//                 </button>
//             </div>

//             <div style={styles.settlementModalBody}>
//                 {/* Row 1: Settlement ID & Vendor ID */}
//                 <div style={styles.settlementFormRow}>
//                     <div style={styles.settlementFormGroup}>
//                         <label style={styles.settlementLabel}>Settlement ID</label>
//                         <input
//                             type="text"
//                             value={selectedSettlement.settlementId}
//                             readOnly
//                             style={styles.settlementReadOnlyInput}
//                         />
//                     </div>
//                     <div style={styles.settlementFormGroup}>
//                         <label style={styles.settlementLabel}>Vendor ID</label>
//                         <input
//                             type="text"
//                             value={selectedSettlement.vendorId}
//                             readOnly
//                             style={styles.settlementReadOnlyInput}
//                         />
//                     </div>
//                 </div>

//                 {/* Row 2: Vendor Name & Current Status */}
//                 <div style={styles.settlementFormRow}>
//                     <div style={styles.settlementFormGroup}>
//                         <label style={styles.settlementLabel}>Vendor Name</label>
//                         <input
//                             type="text"
//                             value={selectedSettlement.holderName || "-"}
//                             readOnly
//                             style={styles.settlementReadOnlyInput}
//                         />
//                     </div>
//                     <div style={styles.settlementFormGroup}>
//                         <label style={styles.settlementLabel}>Current Status</label>
//                         <div style={{ 
//                             ...styles.settlementBadge, 
//                             ...getStatusBadge(selectedSettlement.paymentStatus), 
//                             fontSize: '14px', 
//                             padding: '10px 16px',
//                             display: 'inline-block',
//                             width: '100%',
//                             textAlign: 'center',
//                             boxSizing: 'border-box'
//                         }}>
//                             {selectedSettlement.paymentStatus}
//                         </div>
//                     </div>
//                 </div>

//                 {/* Row 3: Payment Mode & New Status */}
//                 <div style={styles.settlementFormRow}>
//                     <div style={styles.settlementFormGroup}>
//                         <label style={styles.settlementLabel}>Payment Mode</label>
//                         <select
//                             value={pytMode}
//                             onChange={(e) => setPytMode(e.target.value)}
//                             style={styles.settlementSelect}
//                         >
//                             <option value="FT">FT (Fund Transfer)</option>
//                             <option value="NEFT">NEFT</option>
//                             <option value="RTGS">RTGS</option>
//                             <option value="IMPS">IMPS</option>
//                         </select>
//                     </div>
//                     <div style={styles.settlementFormGroup}>
//                         <label style={styles.settlementLabel}>New Status *</label>
//                         <select
//                             value={newStatus}
//                             onChange={(e) => setNewStatus(e.target.value)}
//                             style={styles.settlementSelect}
//                             required
//                         >
//                             <option value="">Select Status</option>
//                             <option value="PENDING">PENDING</option>
//                             <option value="PAID">PAID</option>
//                         </select>
//                     </div>
//                 </div>

//                 {/* Row 4: Remarks - Full Width */}
//                 <div style={styles.settlementFormGroupFull}>
//                     <label style={styles.settlementLabel}>Remarks *</label>
//                     <textarea
//                         value={remarks}
//                         onChange={(e) => setRemarks(e.target.value)}
//                         placeholder="Enter remarks for status update (required)"
//                         rows="3"
//                         style={styles.settlementTextarea}
//                         onFocus={(e) => {
//                             e.target.style.borderColor = '#e66d33';
//                             e.target.style.boxShadow = '0 0 0 3px rgba(230, 109, 51, 0.1)';
//                         }}
//                         onBlur={(e) => {
//                             e.target.style.borderColor = '#e2e8f0';
//                             e.target.style.boxShadow = 'none';
//                         }}
//                         required
//                     />
//                     <small style={{ color: '#718096', fontSize: '12px', marginTop: '4px', display: 'block' }}>
//                         Please provide a reason for the status change
//                     </small>
//                 </div>

//                 {/* Modal Footer */}
//                 <div style={styles.settlementModalFooter}>
//                     <button
//                         onClick={() => setShowStatusModal(false)}
//                         style={{ ...styles.settlementButton, ...styles.settlementButtonSecondary, flex: 1 }}
//                     >
//                         Cancel
//                     </button>
//                     <button
//                         onClick={handleUpdateStatus}
//                         style={{ ...styles.settlementButton, ...styles.settlementButtonPrimary, flex: 1 }}
//                     >
//                         Update Status
//                     </button>
//                 </div>
//             </div>
//         </div>
//     </div>
// )}

//             <style>{`
//                 @keyframes settlementSlideUp {
//                     from { opacity: 0; transform: translateY(30px) scale(0.95); }
//                     to { opacity: 1; transform: translateY(0) scale(1); }
//                 }

//                 @keyframes settlementFadeIn {
//                     from { opacity: 0; }
//                     to { opacity: 1; }
//                 }

//                 .settlement-wrapper {
//                     animation: settlementFadeIn 0.4s ease;
//                 }

//                 /* Table scroll styles */
//                 .settlement-table-wrapper::-webkit-scrollbar {
//                     width: 8px;
//                     height: 8px;
//                 }
//                 .settlement-table-wrapper::-webkit-scrollbar-track {
//                     background: #f1f1f1;
//                     border-radius: 4px;
//                 }
//                 .settlement-table-wrapper::-webkit-scrollbar-thumb {
//                     background: linear-gradient(135deg, #e66d33 0%, #d45a2a 100%);
//                     border-radius: 4px;
//                 }
//                 .settlement-table-wrapper::-webkit-scrollbar-thumb:hover {
//                     background: linear-gradient(135deg, #d45a2a 0%, #b84a1a 100%);
//                 }

//                 /* Stat card hover */
//                 .settlement-stat-card:hover {
//                     transform: translateY(-2px);
//                     box-shadow: 0 4px 12px rgba(0,0,0,0.08);
//                 }

//                 @media (max-width: 768px) {
//                     .settlement-filters {
//                         flex-direction: column !important;
//                         align-items: stretch !important;
//                     }
//                     .settlement-search-group {
//                         min-width: unset !important;
//                     }
//                     .settlement-stats-grid {
//                         grid-template-columns: 1fr 1fr !important;
//                     }
//                     .settlement-modal {
//                         width: 95% !important;
//                         padding: 20px !important;
//                     }
//                 }

//                 @media (max-width: 480px) {
//                     .settlement-stats-grid {
//                         grid-template-columns: 1fr !important;
//                     }
//                     .settlement-stat-value {
//                         font-size: 18px !important;
//                     }
//                     .settlement-table {
//                         font-size: 11px !important;
//                     }
//                     .settlement-table th,
//                     .settlement-table td {
//                         padding: 6px 8px !important;
//                         font-size: 10px !important;
//                     }
//                     .settlement-badge {
//                         font-size: 9px !important;
//                         padding: 2px 8px !important;
//                     }
//                 }
//             `}</style>
//         </div>
//     );
// };

// export default Foodsettlementpage;




import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { useLoader } from '../../../../context/LoaderProvider.jsx';
import {
    getAllSettlementsAPI,
    updateSettlementStatusAPI,
} from "../../../Servicefile/AccountManagementService.jsx";

// ============================================
// PREMIUM ICONS COMPONENT
// ============================================
const Icons = {
    Search: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" />
        </svg>
    ),
    Export: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
        </svg>
    ),
    Clear: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    ),
    Filter: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polygon points="22 3 2 3 10 13 10 21 14 18 14 13 22 3" />
        </svg>
    ),
    Calendar: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
    ),
    Money: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0b5e42" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M8 12h8" />
            <path d="M12 8v8" />
        </svg>
    ),
    Vendor: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
        </svg>
    ),
    Bank: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="6" width="20" height="14" rx="2" />
            <path d="M2 10h20" />
            <path d="M8 14v4" />
            <path d="M12 14v4" />
            <path d="M16 14v4" />
        </svg>
    ),
    Status: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
        </svg>
    ),
    NoData: () => (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
            <rect x="2" y="3" width="20" height="18" rx="2" />
            <line x1="8" y1="21" x2="16" y2="21" />
            <line x1="12" y1="17" x2="12" y2="21" />
            <path d="M8 7h8M8 11h6M8 15h4" />
        </svg>
    ),
    Close: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    ),
    Edit: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
        </svg>
    ),
    Refresh: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M23 4v6h-6M1 20v-6h6" />
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
        </svg>
    ),
    Settlement: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgb(230 109 51)" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M8 12h8" />
            <path d="M12 8v8" />
        </svg>
    ),
    TrendingUp: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
            <polyline points="17 6 23 6 23 12" />
        </svg>
    ),
    TrendingDown: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="23 18 13.5 8.5 8.5 13.5 1 6" />
            <polyline points="17 18 23 18 23 12" />
        </svg>
    ),
    Wallet: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
            <line x1="1" y1="10" x2="23" y2="10" />
        </svg>
    ),
    CheckCircle: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#28a745" strokeWidth="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
    ),
    Clock: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ffc107" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
        </svg>
    ),
    Building: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="4" y="2" width="16" height="20" rx="2" ry="2" />
            <line x1="9" y1="22" x2="15" y2="22" />
            <line x1="9" y1="6" x2="15" y2="6" />
            <line x1="9" y1="10" x2="15" y2="10" />
            <line x1="9" y1="14" x2="15" y2="14" />
        </svg>
    ),
    User: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
        </svg>
    )
};

// ============================================
// PREMIUM STYLES
// ============================================
const styles = {
    settlementContainer: {
        padding: '11px 5px',
        width: '100%',
        maxWidth: '100%',
        overflowX: 'hidden'
    },
    settlementHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 0 16px 0',
        borderBottom: '2px solid #e9ecef',
        flexWrap: 'wrap',
        gap: '12px'
    },
    settlementTitle: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#2d3748',
        letterSpacing: '-0.3px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    settlementTitleBadge: {
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500',
        padding: '2px 12px',
        borderRadius: '12px',
        letterSpacing: '0.3px'
    },
    settlementStatsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
        gap: '14px',
        marginBottom: '16px',
        padding: '18px',
        background: 'white',
        borderRadius: '14px',
        border: '1px solid #edf2f7',
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
    },
    settlementStatCard: {
        textAlign: 'center',
        padding: '8px 4px',
        borderRadius: '10px',
        transition: 'all 0.3s ease',
        cursor: 'default'
    },
    settlementStatValue: {
        fontSize: '26px',
        fontWeight: '700',
        color: '#2d3748',
        lineHeight: '1.2'
    },
    settlementStatLabel: {
        fontSize: '12px',
        color: '#718096',
        fontWeight: '500',
        textTransform: 'uppercase',
        letterSpacing: '0.4px',
        marginTop: '4px'
    },
    settlementFilters: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '10px',
        padding: '12px 0',
        borderBottom: '1px solid #edf2f7',
        marginBottom: '16px'
    },
    settlementSearchGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flex: '1 1 auto',
        minWidth: '280px'
    },
    settlementSelect: {
        padding: '8px 12px',
        border: '2px solid #e2e8f0',
        borderRadius: '10px',
        background: 'white',
        fontSize: '13px',
        fontWeight: '500',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.3s ease',
        height: '42px',
        minWidth: '140px',
        cursor: 'pointer'
    },
    settlementSearchInput: {
        flex: '1',
        padding: '8px 14px 8px 38px',
        border: '2px solid #e2e8f0',
        borderRadius: '10px',
        fontSize: '13px',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.3s ease',
        height: '42px',
        background: 'white',
        minWidth: '180px'
    },
    settlementDateInput: {
        padding: '8px 14px',
        border: '2px solid #e2e8f0',
        borderRadius: '10px',
        fontSize: '13px',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.3s ease',
        height: '42px',
        background: 'white',
        minWidth: '150px'
    },
    settlementButton: {
        padding: '8px 18px',
        borderRadius: '10px',
        border: 'none',
        fontWeight: '600',
        fontSize: '13px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        height: '42px',
        whiteSpace: 'nowrap'
    },
    settlementButtonPrimary: {
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        color: 'white',
        boxShadow: '0 4px 15px rgba(230, 109, 51, 0.3)'
    },
    settlementButtonSecondary: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    settlementButtonExport: {
        background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
        color: 'white',
        boxShadow: '0 4px 15px rgba(40, 167, 69, 0.3)'
    },
    settlementTableWrapper: {
        borderRadius: '12px',
        border: '1px solid #edf2f7',
        background: 'white',
        overflow: 'auto',
        maxHeight: '60vh',
        position: 'relative',
        width: '100%',
        maxWidth: '100%'
    },
    settlementTable: {
        width: '100%',
        fontSize: '13px',
        borderCollapse: 'collapse',
        minWidth: '1700px'
    },
    settlementTableHead: {
        position: 'sticky',
        top: 0,
        zIndex: 10
    },
    settlementTableHeader: {
        padding: '10px 12px',
        textAlign: 'center',
        fontWeight: '600',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: 'white',
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        borderBottom: '2px solid #d45a1a',
        whiteSpace: 'nowrap'
    },
    settlementTableCell: {
        padding: '10px 12px',
        borderBottom: '1px solid #f1f5f9',
        color: '#2d3748',
        fontSize: '13px',
        textAlign: 'center',
        verticalAlign: 'middle'
    },
    settlementBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '3px 12px',
        borderRadius: '20px',
        fontSize: '11px',
        fontWeight: '600',
        letterSpacing: '0.3px'
    },
    settlementBadgePaid: {
        background: '#c6f6d5',
        color: '#276749'
    },
    settlementBadgePending: {
        background: '#fefcbf',
        color: '#975a16'
    },
    settlementBadgeDefault: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    settlementEmptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px',
        color: '#a0aec0'
    },
    settlementEmptyStateText: {
        marginTop: '16px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#4a5568'
    },
    settlementEmptyStateSubtext: {
        fontSize: '13px',
        color: '#a0aec0',
        marginTop: '4px'
    },
    settlementModalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        backdropFilter: 'blur(4px)',
        padding: '20px'
    },
    settlementModal: {
        background: 'white',
        borderRadius: '16px',
        padding: '28px',
        width: '560px',
        maxWidth: '95%',
        maxHeight: '85vh',
        scrollbarWidth: 'none',
        overflowY: 'auto',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        animation: 'settlementSlideUp 0.3s ease'
    },
    settlementModalHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingBottom: '16px',
        borderBottom: '2px solid #f0f0f0',
        marginBottom: '20px'
    },
    settlementModalTitle: {
        fontSize: '20px',
        fontWeight: '700',
        color: '#1a1a2e',
        margin: 0,
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    settlementModalClose: {
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: '#a0aec0',
        transition: 'all 0.3s ease',
        padding: '4px'
    },
    settlementModalBody: {
        padding: '0 0 4px 0'
    },
    settlementFormRow: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '16px',
        marginBottom: '16px'
    },
    settlementFormGroup: {
        marginBottom: '16px'
    },
    settlementFormGroupFull: {
        marginBottom: '16px',
        gridColumn: '1 / -1'
    },
    settlementLabel: {
        display: 'block',
        marginBottom: '6px',
        fontSize: '13px',
        fontWeight: '600',
        color: '#4a5568'
    },
    settlementReadOnlyInput: {
        width: '100%',
        padding: '10px 14px',
        borderRadius: '8px',
        border: '2px solid #edf2f7',
        fontSize: '13px',
        color: '#2d3748',
        outline: 'none',
        background: '#f7fafc',
        cursor: 'not-allowed',
        boxSizing: 'border-box'
    },
    settlementTextarea: {
        width: '100%',
        padding: '10px 14px',
        borderRadius: '8px',
        border: '2px solid #e2e8f0',
        fontSize: '13px',
        outline: 'none',
        transition: 'all 0.3s ease',
        resize: 'vertical',
        boxSizing: 'border-box',
        fontFamily: 'inherit'
    },
    settlementModalFooter: {
        display: 'flex',
        gap: '10px',
        paddingTop: '16px',
        borderTop: '2px solid #f0f0f0',
        marginTop: '4px'
    },
    settlementAmount: {
        fontWeight: '600',
        color: '#0b5e42'
    },
    settlementRemarksCell: {
        maxWidth: '150px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        cursor: 'pointer',
        color: '#4a5568'
    },
    settlementPaymentMode: {
        display: 'inline-block',
        padding: '2px 10px',
        borderRadius: '4px',
        fontSize: '11px',
        fontWeight: '600'
    },
    settlementPaymentModeFT: {
        background: '#bee3f8',
        color: '#2a4365'
    },
    settlementPaymentModeNEFT: {
        background: '#c6f6d5',
        color: '#276749'
    },
    settlementPaymentModeRTGS: {
        background: '#e9d8fd',
        color: '#553c9a'
    },
    settlementPaymentModeIMPS: {
        background: '#fefcbf',
        color: '#975a16'
    },
    settlementPaymentModeDefault: {
        background: '#e2e8f0',
        color: '#4a5568'
    },

    // ============================================
    // VENDOR DASHBOARD CARD STYLES
    // ============================================
    vendorDashboardGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: '20px',
        marginBottom: '20px'
    },
    vendorCard: {
        background: 'white',
        borderRadius: '16px',
        border: '1px solid #edf2f7',
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
        overflow: 'hidden',
        transition: 'all 0.3s ease'
    },
    vendorCardHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '16px 24px',
        background: 'linear-gradient(135deg, #e66d33 0%, #e66d33 100%)',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        flexWrap: 'wrap',
        gap: '12px'
    },
    vendorCardHeaderLeft: {
        display: 'flex',
        alignItems: 'center',
        gap: '14px'
    },
    vendorAvatar: {
        width: '48px',
        height: '48px',
        borderRadius: '50%',
        background: 'rgba(255,255,255,0.2)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '24px',
        color: 'white',
        backdropFilter: 'blur(10px)'
    },
    vendorHeaderInfo: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2px'
    },
    vendorHeaderName: {
        margin: 0,
        fontSize: '18px',
        fontWeight: '700',
        color: 'white'
    },
    vendorHeaderId: {
        fontSize: '12px',
        color: 'white',


    },
    vendorHeaderCity: {
        fontSize: '13px',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        gap: '4px'
    },
    vendorHeaderRight: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        flexWrap: 'wrap'
    },
    vendorHeaderStat: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '4px 12px',
        borderRadius: '12px',
        background: 'rgba(255,255,255,0.15)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500'
    },
    vendorHeaderStatPaid: {
        background: 'white',
        color: '#ff6b6b'
    },
    vendorHeaderStatPending: {
        background: 'white',
        color: '#ff6b6b'
    },
    vendorHeaderStatRejected: {
        background: 'white',
        color: '#ff6b6b'
    },
    expandIcon: {
        color: 'white',
        fontSize: '20px',
        fontWeight: '700',
        marginLeft: '5px',
        transition: 'transform 0.3s ease'
    },
    expandIconRotated: {
        transform: 'rotate(180deg)'
    },

    // Vendor Dashboard Body
    vendorDashboardBody: {
        padding: '20px 24px 24px 24px',
        animation: 'slideDown 0.3s ease'
    },

    // KPI Cards Grid
    kpiGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
        gap: '14px',
        marginBottom: '20px'
    },
    kpiCard: {
        background: '#f8f9fa',
        borderRadius: '12px',
        padding: '16px',
        border: '1px solid #edf2f7',
        transition: 'all 0.3s ease'
    },
    kpiCardHover: {
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
    },
    kpiLabel: {
        fontSize: '11px',
        fontWeight: '600',
        color: '#718096',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        marginBottom: '6px'
    },
    kpiValue: {
        fontSize: '24px',
        fontWeight: '700',
        color: '#2d3748'
    },
    kpiSubtext: {
        fontSize: '12px',
        color: '#a0aec0',
        marginTop: '4px'
    },
    kpiIcon: {
        fontSize: '20px',
        marginBottom: '4px'
    },

    // Vendor Details Section
    vendorDetailsGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '16px',
        marginBottom: '20px'
    },
    vendorDetailCard: {
        background: '#f8f9fa',
        borderRadius: '12px',
        padding: '16px',
        border: '1px solid #edf2f7'
    },
    vendorDetailTitle: {
        fontSize: '13px',
        fontWeight: '600',
        color: '#4a5568',
        marginBottom: '10px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    },
    vendorDetailRow: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '6px 0',
        borderBottom: '1px solid #e9ecef',
        fontSize: '13px'
    },
    vendorDetailRowLast: {
        borderBottom: 'none'
    },
    vendorDetailLabel: {
        color: '#718096'
    },
    vendorDetailValue: {
        fontWeight: '500',
        color: '#2d3748'
    },

    // Settlement Items Table inside Vendor Card
    vendorSettlementTable: {
        width: '100%',
        fontSize: '12px',
        borderCollapse: 'collapse',
        marginTop: '10px'
    },
    vendorSettlementHeader: {
        padding: '8px 10px',
        textAlign: 'left',
        fontWeight: '600',
        fontSize: '10px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: '#718096',
        borderBottom: '2px solid #edf2f7'
    },
    vendorSettlementCell: {
        padding: '8px 10px',
        borderBottom: '1px solid #f1f5f9',
        color: '#2d3748',
        fontSize: '12px'
    },
    vendorSettlementAction: {
        padding: '4px 12px',
        borderRadius: '6px',
        border: 'none',
        fontWeight: '600',
        fontSize: '11px',
        cursor: 'pointer',
        transition: 'all 0.3s ease'
    },

    // Date Filter Section
    dateFilterSection: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '10px',
        padding: '12px 16px',
        background: '#f8f9fa',
        borderRadius: '10px',
        marginBottom: '16px',
        border: '1px solid #edf2f7'
    },
    dateFilterButton: {
        padding: '6px 16px',
        borderRadius: '20px',
        border: '2px solid #e2e8f0',
        background: 'white',
        fontSize: '12px',
        fontWeight: '500',
        color: '#4a5568',
        cursor: 'pointer',
        transition: 'all 0.3s ease'
    },
    dateFilterButtonActive: {
        borderColor: '#e66d33',
        background: '#e66d33',
        color: 'white'
    },
    dateFilterDivider: {
        color: '#e2e8f0',
        fontSize: '18px',
        fontWeight: '300'
    }
};

// ============================================
// VENDOR DASHBOARD CARD COMPONENT
// ============================================
const VendorDashboardCard = ({ vendorId, vendorData, onUpdateStatus }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [selectedSettlement, setSelectedSettlement] = useState(null);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [newStatus, setNewStatus] = useState('');
    const [remarks, setRemarks] = useState('');
    const [pytMode, setPytMode] = useState('FT');

    const toggleExpand = () => setIsExpanded(!isExpanded);

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount || 0);
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toISOString().split('T')[0];
    };

    const getStatusBadge = (status) => {
        if (!status) return styles.settlementBadgeDefault;
        if (status === "PAID") return styles.settlementBadgePaid;
        if (status === "PENDING") return styles.settlementBadgePending;
        return styles.settlementBadgeDefault;
    };

    const getPaymentModeStyle = (mode) => {
        switch (mode) {
            case "FT": return styles.settlementPaymentModeFT;
            case "NEFT": return styles.settlementPaymentModeNEFT;
            case "RTGS": return styles.settlementPaymentModeRTGS;
            case "IMPS": return styles.settlementPaymentModeIMPS;
            default: return styles.settlementPaymentModeDefault;
        }
    };

    // Calculate KPIs
    const totalSettlements = vendorData.length;
    const totalAmount = vendorData.reduce((sum, item) => sum + (item.finalAmount || 0), 0);
    const paidCount = vendorData.filter(item => item.paymentStatus === "PAID").length;
    const pendingCount = vendorData.filter(item => item.paymentStatus === "PENDING").length;
    const totalCash = vendorData.reduce((sum, item) => sum + (item.totalCash || 0), 0);
    const totalCommission = vendorData.reduce((sum, item) => sum + (item.commission || 0), 0);

    const handleStatusUpdateClick = (settlement) => {
        setSelectedSettlement(settlement);
        setNewStatus(settlement.paymentStatus);
        setRemarks(settlement.remarks || '');
        setPytMode(settlement.pytMode || 'FT');
        setShowUpdateModal(true);
    };

    const handleUpdateStatus = async () => {
        if (!selectedSettlement || !newStatus) {
            alert("Please select a status");
            return;
        }
        if (!remarks.trim()) {
            alert("Please enter remarks for the status update");
            return;
        }

        const settlementId = selectedSettlement.settlementId;
        const updateData = {
            settlementId: settlementId,
            vendorId: selectedSettlement.vendorId,
            totalCgst: selectedSettlement.totalCgst || 0,
            totalSgst: selectedSettlement.totalSgst || 0,
            totalGrandTotal: selectedSettlement.totalGrandTotal || 0,
            totalServiceCharges: selectedSettlement.totalServiceCharges || 0,
            totalPlatformCharges: selectedSettlement.totalPlatformCharges || 0,
            totalOnlinePayment: selectedSettlement.totalOnlinePayment || 0,
            totalAmountBeforeTds: selectedSettlement.totalAmountBeforeTds || 0,
            tdsAmount: selectedSettlement.tdsAmount || 0,
            amountAfterTds: selectedSettlement.amountAfterTds || 0,
            amountAfterCash: selectedSettlement.amountAfterCash || 0,
            finalAmount: selectedSettlement.finalAmount || 0,
            totalCash: selectedSettlement.totalCash || 0,
            description: selectedSettlement.description || "",
            fromDate: selectedSettlement.fromDate || new Date().toISOString(),
            toDate: selectedSettlement.toDate || new Date().toISOString(),
            totalVendorPlatformCharges: selectedSettlement.totalVendorPlatformCharges || 0,
            totalVendorPlatformChargesGst: selectedSettlement.totalVendorPlatformChargesGst || 0,
            holderName: selectedSettlement.holderName || "",
            accountNumber: selectedSettlement.accountNumber || "",
            ifscCode: selectedSettlement.ifscCode || "",
            settlementDate: selectedSettlement.settlementDate || new Date().toISOString().split("T")[0],
            paymentStatus: newStatus,
            superadminAccNo: selectedSettlement.superadminAccNo || "",
            pytMode: pytMode,
            remarks: remarks,
            totalWalletPayment: selectedSettlement.totalWalletPayment || 0,
            commission: selectedSettlement.commission || 0,
        };

        try {
            await updateSettlementStatusAPI(settlementId, updateData);
            alert("Status updated successfully!");
            onUpdateStatus();
            setShowUpdateModal(false);
            setSelectedSettlement(null);
            setNewStatus('');
            setRemarks('');
            setPytMode('FT');
        } catch (err) {
            console.error("Error updating status:", err);
            alert(`Failed to update status: ${err.response?.data?.message || err.message}`);
        }
    };

    return (
        <>
            <div style={styles.vendorCard}>
                {/* Vendor Card Header - Click to Expand */}
                <div style={styles.vendorCardHeader} onClick={toggleExpand}>
                    <div style={styles.vendorCardHeaderLeft}>
                        <div style={styles.vendorAvatar}>
                            {vendorData[0]?.vendorLogo || '🏪'}
                        </div>
                        <div style={styles.vendorHeaderInfo}>
                            <h3 style={styles.vendorHeaderName}>
                                {vendorData[0]?.holderName || vendorId}
                            </h3>
                            <div style={styles.vendorHeaderId}>
                                Vendor ID: {vendorId}
                            </div>
                            <div style={styles.vendorHeaderCity}>
                                <Icons.Building /> {vendorData[0]?.city || 'N/A'}
                            </div>
                        </div>
                    </div>
                    <div style={styles.vendorHeaderRight}>
                        <span style={{ ...styles.vendorHeaderStat, ...styles.vendorHeaderStatPending }}>
                            <Icons.Clock /> {pendingCount} Pending
                        </span>
                        <span style={{ ...styles.vendorHeaderStat, ...styles.vendorHeaderStatPaid }}>
                            <Icons.CheckCircle /> {paidCount} Paid
                        </span>
                        <span style={{ ...styles.vendorHeaderStat }}>
                            <Icons.Money /> {formatCurrency(totalAmount)}
                        </span>
                        <span style={{
                            ...styles.expandIcon,
                            ...(isExpanded ? styles.expandIconRotated : {})
                        }}>
                            ▼
                        </span>
                    </div>
                </div>

                {/* Expanded Content - Vendor Dashboard */}
                {isExpanded && (
                    <div style={styles.vendorDashboardBody}>
                        {/* KPI Cards Grid */}
                        <div style={styles.kpiGrid}>
                            <div style={styles.kpiCard}>
                                <div style={styles.kpiIcon}>📊</div>
                                <div style={styles.kpiLabel}>Total Settlements</div>
                                <div style={styles.kpiValue}>{totalSettlements}</div>
                            </div>
                            <div style={styles.kpiCard}>
                                <div style={styles.kpiIcon}>💰</div>
                                <div style={styles.kpiLabel}>Total Amount</div>
                                <div style={styles.kpiValue}>{formatCurrency(totalAmount)}</div>
                            </div>
                            <div style={styles.kpiCard}>
                                <div style={styles.kpiIcon}>✅</div>
                                <div style={styles.kpiLabel}>Paid</div>
                                <div style={styles.kpiValue}>{paidCount}</div>
                                <div style={styles.kpiSubtext}>{formatCurrency(totalAmount * (paidCount / (totalSettlements || 1)))}</div>
                            </div>
                            <div style={styles.kpiCard}>
                                <div style={styles.kpiIcon}>⏳</div>
                                <div style={styles.kpiLabel}>Pending</div>
                                <div style={styles.kpiValue}>{pendingCount}</div>
                                <div style={styles.kpiSubtext}>{formatCurrency(totalAmount * (pendingCount / (totalSettlements || 1)))}</div>
                            </div>
                            <div style={styles.kpiCard}>
                                <div style={styles.kpiIcon}>💳</div>
                                <div style={styles.kpiLabel}>Total Cash</div>
                                <div style={styles.kpiValue}>{formatCurrency(totalCash)}</div>
                            </div>
                            <div style={styles.kpiCard}>
                                <div style={styles.kpiIcon}>📈</div>
                                <div style={styles.kpiLabel}>Commission</div>
                                <div style={styles.kpiValue}>{formatCurrency(totalCommission)}</div>
                            </div>
                        </div>

                        {/* Vendor Details */}
                        <div style={styles.vendorDetailsGrid}>
                            <div style={styles.vendorDetailCard}>
                                <div style={styles.vendorDetailTitle}>
                                    <Icons.User /> Bank Details
                                </div>
                                <div style={styles.vendorDetailRow}>
                                    <span style={styles.vendorDetailLabel}>Account Holder</span>
                                    <span style={styles.vendorDetailValue}>{vendorData[0]?.holderName || '-'}</span>
                                </div>
                                <div style={styles.vendorDetailRow}>
                                    <span style={styles.vendorDetailLabel}>Account Number</span>
                                    <span style={styles.vendorDetailValue}>{vendorData[0]?.accountNumber || '-'}</span>
                                </div>
                                <div style={{ ...styles.vendorDetailRow, ...styles.vendorDetailRowLast }}>
                                    <span style={styles.vendorDetailLabel}>IFSC Code</span>
                                    <span style={styles.vendorDetailValue}>{vendorData[0]?.ifscCode || '-'}</span>
                                </div>
                            </div>
                            <div style={styles.vendorDetailCard}>
                                <div style={styles.vendorDetailTitle}>
                                    <Icons.Wallet /> Summary
                                </div>
                                <div style={styles.vendorDetailRow}>
                                    <span style={styles.vendorDetailLabel}>Admin Account</span>
                                    <span style={styles.vendorDetailValue}>{formatCurrency(vendorData[0]?.superadminAccNo || '-')}</span>
                                </div>
                                <div style={styles.vendorDetailRow}>
                                    <span style={styles.vendorDetailLabel}>Total Sales</span>
                                    <span style={styles.vendorDetailValue}>{formatCurrency(vendorData.reduce((sum, item) => sum + (item.totalAmountBeforeTds || 0), 0))}</span>
                                </div>
                                <div style={{ ...styles.vendorDetailRow, ...styles.vendorDetailRowLast }}>
                                    <span style={styles.vendorDetailLabel}>Service Charges</span>
                                    <span style={styles.vendorDetailValue}>{formatCurrency(vendorData.reduce((sum, item) => sum + (item.tdsAmount || 0), 0))}</span>
                                </div>
                            </div>
                        </div>

                        {/* Settlement Items Table */}
                        <div style={{ ...styles.vendorDetailCard, padding: '0', background: 'white' }}>
                            <div style={{ ...styles.vendorDetailTitle, padding: '16px 16px 0 16px' }}>
                                <Icons.Settlement /> Settlement History
                            </div>
                            <div style={{ overflowX: 'auto' }}>
                                <table style={styles.vendorSettlementTable}>
                                    <thead>
                                        <tr>
                                            <th style={styles.vendorSettlementHeader}>#</th>
                                            <th style={styles.vendorSettlementHeader}>Settlement ID</th>
                                            <th style={styles.vendorSettlementHeader}>From</th>
                                            <th style={styles.vendorSettlementHeader}>To</th>
                                            <th style={styles.vendorSettlementHeader}>Amount</th>
                                            <th style={styles.vendorSettlementHeader}>Cash</th>
                                            <th style={styles.vendorSettlementHeader}>Mode</th>
                                            <th style={styles.vendorSettlementHeader}>Status</th>
                                            <th style={styles.vendorSettlementHeader}>Remarks</th>
                                            <th style={styles.vendorSettlementHeader}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {vendorData.map((item, index) => (
                                            <tr key={item.settlementId || index}>
                                                <td style={styles.vendorSettlementCell}>{index + 1}</td>
                                                <td style={{ ...styles.vendorSettlementCell, fontFamily: 'monospace', fontSize: '11px' }}>
                                                    {item.settlementId}
                                                </td>
                                                <td style={styles.vendorSettlementCell}>{formatDate(item.fromDate)}</td>
                                                <td style={styles.vendorSettlementCell}>{formatDate(item.toDate)}</td>
                                                <td style={{ ...styles.vendorSettlementCell, fontWeight: '600', color: '#0b5e42' }}>
                                                    {formatCurrency(item.finalAmount)}
                                                </td>
                                                <td style={styles.vendorSettlementCell}>{formatCurrency(item.totalCash)}</td>
                                                <td style={styles.vendorSettlementCell}>
                                                    <span style={{ ...styles.settlementPaymentMode, ...getPaymentModeStyle(item.pytMode) }}>
                                                        {item.pytMode || "FT"}
                                                    </span>
                                                </td>
                                                <td style={styles.vendorSettlementCell}>
                                                    <span style={{ ...styles.settlementBadge, ...getStatusBadge(item.paymentStatus) }}>
                                                        {item.paymentStatus}
                                                    </span>
                                                </td>
                                                <td style={styles.vendorSettlementCell}>
                                                    {item.remarks ? (
                                                        <div style={styles.settlementRemarksCell} title={item.remarks}>
                                                            {item.remarks}
                                                        </div>
                                                    ) : "-"}
                                                </td>
                                                <td style={styles.vendorSettlementCell}>
                                                    {item.paymentStatus !== "PAID" ? (
                                                        <button
                                                            onClick={() => handleStatusUpdateClick(item)}
                                                            style={{
                                                                ...styles.vendorSettlementAction,
                                                                background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
                                                                color: 'white'
                                                            }}
                                                        >
                                                            Update
                                                        </button>
                                                    ) : (
                                                        <span style={{ color: '#48bb78', fontWeight: '600', fontSize: '11px' }}>
                                                            ✓ Completed
                                                        </span>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* Update Status Modal */}
            {showUpdateModal && selectedSettlement && (
                <div style={styles.settlementModalOverlay} onClick={() => setShowUpdateModal(false)}>
                    <div style={styles.settlementModal} onClick={(e) => e.stopPropagation()}>
                        <div style={styles.settlementModalHeader}>
                            <h3 style={styles.settlementModalTitle}>
                                <Icons.Edit style={{ color: '#e66d33' }} /> Update Status
                            </h3>
                            <button style={styles.settlementModalClose} onClick={() => setShowUpdateModal(false)}>
                                <Icons.Close />
                            </button>
                        </div>

                        <div style={styles.settlementModalBody}>
                            <div style={styles.settlementFormRow}>
                                <div style={styles.settlementFormGroup}>
                                    <label style={styles.settlementLabel}>Settlement ID</label>
                                    <input
                                        type="text"
                                        value={selectedSettlement.settlementId}
                                        readOnly
                                        style={styles.settlementReadOnlyInput}
                                    />
                                </div>
                                <div style={styles.settlementFormGroup}>
                                    <label style={styles.settlementLabel}>Vendor ID</label>
                                    <input
                                        type="text"
                                        value={selectedSettlement.vendorId}
                                        readOnly
                                        style={styles.settlementReadOnlyInput}
                                    />
                                </div>
                            </div>

                            <div style={styles.settlementFormRow}>
                                <div style={styles.settlementFormGroup}>
                                    <label style={styles.settlementLabel}>Vendor Name</label>
                                    <input
                                        type="text"
                                        value={selectedSettlement.holderName || "-"}
                                        readOnly
                                        style={styles.settlementReadOnlyInput}
                                    />
                                </div>
                                <div style={styles.settlementFormGroup}>
                                    <label style={styles.settlementLabel}>Current Status</label>
                                    <div style={{
                                        ...styles.settlementBadge,
                                        ...getStatusBadge(selectedSettlement.paymentStatus),
                                        fontSize: '14px',
                                        padding: '10px 16px',
                                        display: 'inline-block',
                                        width: '100%',
                                        textAlign: 'center',
                                        boxSizing: 'border-box'
                                    }}>
                                        {selectedSettlement.paymentStatus}
                                    </div>
                                </div>
                            </div>

                            <div style={styles.settlementFormRow}>
                                <div style={styles.settlementFormGroup}>
                                    <label style={styles.settlementLabel}>Payment Mode</label>
                                    <select
                                        value={pytMode}
                                        onChange={(e) => setPytMode(e.target.value)}
                                        style={styles.settlementSelect}
                                    >
                                        <option value="FT">FT (Fund Transfer)</option>
                                        <option value="NEFT">NEFT</option>
                                        <option value="RTGS">RTGS</option>
                                        <option value="IMPS">IMPS</option>
                                    </select>
                                </div>
                                <div style={styles.settlementFormGroup}>
                                    <label style={styles.settlementLabel}>New Status *</label>
                                    <select
                                        value={newStatus}
                                        onChange={(e) => setNewStatus(e.target.value)}
                                        style={styles.settlementSelect}
                                        required
                                    >
                                        <option value="">Select Status</option>
                                        <option value="PENDING">PENDING</option>
                                        <option value="PAID">PAID</option>
                                    </select>
                                </div>
                            </div>

                            <div style={styles.settlementFormGroupFull}>
                                <label style={styles.settlementLabel}>Remarks *</label>
                                <textarea
                                    value={remarks}
                                    onChange={(e) => setRemarks(e.target.value)}
                                    placeholder="Enter remarks for status update (required)"
                                    rows="3"
                                    style={styles.settlementTextarea}
                                    onFocus={(e) => {
                                        e.target.style.borderColor = '#e66d33';
                                        e.target.style.boxShadow = '0 0 0 3px rgba(230, 109, 51, 0.1)';
                                    }}
                                    onBlur={(e) => {
                                        e.target.style.borderColor = '#e2e8f0';
                                        e.target.style.boxShadow = 'none';
                                    }}
                                    required
                                />
                                <small style={{ color: '#718096', fontSize: '12px', marginTop: '4px', display: 'block' }}>
                                    Please provide a reason for the status change
                                </small>
                            </div>

                            <div style={styles.settlementModalFooter}>
                                <button
                                    onClick={() => setShowUpdateModal(false)}
                                    style={{ ...styles.settlementButton, ...styles.settlementButtonSecondary, flex: 1 }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleUpdateStatus}
                                    style={{ ...styles.settlementButton, ...styles.settlementButtonPrimary, flex: 1 }}
                                >
                                    Update Status
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

// ============================================
// MAIN COMPONENT - Foodsettlementpage
// ============================================
const Foodsettlementpage = () => {
    const [searchType, setSearchType] = useState("vendorId");
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
    const [dateFilterType, setDateFilterType] = useState("all");
    const [customStartDate, setCustomStartDate] = useState("");
    const [customEndDate, setCustomEndDate] = useState("");

    const searchOptions = [
        { value: "vendorId", label: "Vendor ID" },
        { value: "holderName", label: "Vendor Name" },
        { value: "accountNumber", label: "Account Number" },
        { value: "ifscCode", label: "IFSC Code" }
    ];

    const [settlements, setSettlements] = useState([]);
    const [vendorGroups, setVendorGroups] = useState({});
    const [filteredVendorGroups, setFilteredVendorGroups] = useState({});

    const { showLoader, hideLoader } = useLoader();

    useEffect(() => {
        fetchSettlements();
    }, []);

    const fetchSettlements = async () => {
        try {
            showLoader();
            const res = await getAllSettlementsAPI();
            const data = res.settlements || res;
            const dataWithSno = Array.isArray(data)
                ? data.map((item, index) => ({
                    ...item,
                    sno: index + 1,
                }))
                : [];
            setSettlements(dataWithSno);
            groupByVendor(dataWithSno);
        } catch (err) {
            console.error("Error fetching settlements:", err);
        } finally {
            hideLoader();
        }
    };

    const groupByVendor = (data) => {
        const grouped = data.reduce((acc, item) => {
            const vendorId = item.vendorId;
            if (!acc[vendorId]) {
                acc[vendorId] = [];
            }
            acc[vendorId].push(item);
            return acc;
        }, {});
        setVendorGroups(grouped);
        setFilteredVendorGroups(grouped);
    };

    const getPlaceholderText = () => {
        switch (searchType) {
            case "vendorId": return "Search by Vendor ID...";
            case "holderName": return "Search by Vendor Name...";
            case "accountNumber": return "Search by Account Number...";
            case "ifscCode": return "Search by IFSC Code...";
            default: return "Search...";
        }
    };

    // Date filter logic
    const applyDateFilter = (data) => {
        if (dateFilterType === "all") return data;

        const now = new Date();
        let startDate = new Date();
        let endDate = new Date();

        switch (dateFilterType) {
            case "today":
                startDate = new Date(now.setHours(0, 0, 0, 0));
                endDate = new Date(now.setHours(23, 59, 59, 999));
                break;
            case "week":
                const day = now.getDay();
                startDate = new Date(now);
                startDate.setDate(now.getDate() - day);
                startDate.setHours(0, 0, 0, 0);
                endDate = new Date(now);
                endDate.setDate(now.getDate() + (6 - day));
                endDate.setHours(23, 59, 59, 999);
                break;
            case "month":
                startDate = new Date(now.getFullYear(), now.getMonth(), 1);
                endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);
                break;
            case "custom":
                if (customStartDate && customEndDate) {
                    startDate = new Date(customStartDate);
                    endDate = new Date(customEndDate);
                    endDate.setHours(23, 59, 59, 999);
                } else {
                    return data;
                }
                break;
            default:
                return data;
        }

        return data.filter(item => {
            const settlementDate = new Date(item.settlementDate || item.fromDate);
            return settlementDate >= startDate && settlementDate <= endDate;
        });
    };

    const applyFilters = useMemo(() => {
        let filtered = { ...vendorGroups };

        // Search filter
        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase().trim();
            const filteredKeys = Object.keys(filtered).filter(vendorId => {
                const items = filtered[vendorId];
                return items.some(item => {
                    const fieldValue = item[searchType];
                    return fieldValue && fieldValue.toString().toLowerCase().includes(query);
                });
            });
            filtered = Object.fromEntries(
                Object.entries(filtered).filter(([key]) => filteredKeys.includes(key))
            );
        }

        // Status filter
        if (selectedStatusFilter) {
            const filteredKeys = Object.keys(filtered).filter(vendorId => {
                const items = filtered[vendorId];
                return items.some(item => item.paymentStatus === selectedStatusFilter);
            });
            filtered = Object.fromEntries(
                Object.entries(filtered).filter(([key]) => filteredKeys.includes(key))
            );
        }

        // Date filter
        const dateFiltered = Object.fromEntries(
            Object.entries(filtered).map(([vendorId, items]) => {
                const filteredItems = applyDateFilter(items);
                return [vendorId, filteredItems];
            }).filter(([_, items]) => items.length > 0)
        );

        return dateFiltered;
    }, [vendorGroups, searchQuery, searchType, selectedStatusFilter, dateFilterType, customStartDate, customEndDate]);

    useEffect(() => {
        setFilteredVendorGroups(applyFilters);
    }, [applyFilters]);

    const clearAllFilters = () => {
        setSearchQuery("");
        setSelectedStatusFilter("");
        setDateFilterType("all");
        setCustomStartDate("");
        setCustomEndDate("");
    };

    const uniqueStatuses = useMemo(() => {
        const statuses = settlements.map(item => item.paymentStatus).filter(Boolean);
        return [...new Set(statuses)].sort();
    }, [settlements]);

    const handleExport = () => {
        const allItems = Object.values(vendorGroups).flat();
        if (allItems.length === 0) {
            alert("There is no data to export.");
            return;
        }

        const escapeCsvField = (field) => {
            const str = String(field ?? '');
            if (str.includes(',') || str.includes('"') || str.includes('\n')) {
                return `"${str.replace(/"/g, '""')}"`;
            }
            return str;
        };

        const headers = [
            "S.NO", "Vendor ID", "Vendor Name", "Total Sales", "Service Charges",
            "Commission Charges", "To Settle", "Total Cash", "From Date", "To Date",
            "Admin Account", "Vendor Account", "IFSC Code", "Settlement Date",
            "Status", "Payment Mode", "Remarks"
        ];

        const csvRows = allItems.map((item) => [
            item.sno || '',
            item.vendorId || '',
            item.holderName || '',
            item.totalAmountBeforeTds || 0,
            item.tdsAmount || 0,
            item.commission || 0,
            item.finalAmount || 0,
            item.totalCash || 0,
            formatDate(item.fromDate),
            formatDate(item.toDate),
            item.superadminAccNo || '',
            item.accountNumber || '',
            item.ifscCode || '',
            item.settlementDate || '',
            item.paymentStatus || '',
            item.pytMode || 'FT',
            item.remarks || ''
        ]);

        const csvString = [
            headers.map(escapeCsvField).join(','),
            ...csvRows.map(row => row.map(escapeCsvField).join(','))
        ].join('\r\n');

        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", `settlements_${new Date().toISOString().split('T')[0]}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const formatDate = (dateString) => {
        if (!dateString) return "-";
        const date = new Date(dateString);
        return date.toISOString().split("T")[0];
    };

    const getStatusBadge = (status) => {
        if (!status) return styles.settlementBadgeDefault;
        if (status === "PAID") return styles.settlementBadgePaid;
        if (status === "PENDING") return styles.settlementBadgePending;
        return styles.settlementBadgeDefault;
    };

    // Calculate overall stats
    const allItems = Object.values(vendorGroups).flat();
    const totalSettlements = allItems.length;
    const totalAmount = allItems.reduce((sum, item) => sum + (item.finalAmount || 0), 0);
    const paidCount = allItems.filter(item => item.paymentStatus === "PAID").length;
    const pendingCount = allItems.filter(item => item.paymentStatus === "PENDING").length;
    const totalVendors = Object.keys(vendorGroups).length;

    return (
        <div className="settlement-wrapper" style={styles.settlementContainer}>
            {/* Header */}
            {/* <div style={styles.settlementHeader}>
                <h2 style={styles.settlementTitle}>
                    <Icons.Settlement /> Vendor Settlements Dashboard
                    <span style={styles.settlementTitleBadge}>
                        {totalVendors} Vendors
                    </span>
                </h2>
                <button onClick={handleExport} style={{ ...styles.settlementButton, ...styles.settlementButtonExport }}>
                    <Icons.Export /> Export All
                </button>
            </div> */}

            {/* Stats Grid */}
            <div style={styles.settlementStatsGrid}>
                <div style={styles.settlementStatCard}>
                    <div style={styles.settlementStatValue}>{totalVendors}</div>
                    <div style={styles.settlementStatLabel}>Total Vendors</div>
                </div>
                <div style={styles.settlementStatCard}>
                    <div style={styles.settlementStatValue}>{totalSettlements}</div>
                    <div style={styles.settlementStatLabel}>Total Settlements</div>
                </div>
                <div style={styles.settlementStatCard}>
                    <div style={{ ...styles.settlementStatValue, color: '#28a745' }}>
                        ₹{Number(totalAmount).toFixed(2)}
                    </div>
                    <div style={styles.settlementStatLabel}>Total Amount</div>
                </div>
                <div style={styles.settlementStatCard}>
                    <div style={{ ...styles.settlementStatValue, color: '#28a745' }}>
                        {paidCount}
                    </div>
                    <div style={styles.settlementStatLabel}>Paid</div>
                </div>
                <div style={styles.settlementStatCard}>
                    <div style={{ ...styles.settlementStatValue, color: '#ffc107' }}>
                        {pendingCount}
                    </div>
                    <div style={styles.settlementStatLabel}>Pending</div>
                </div>
            </div>

            {/* Date Filter Section */}
            <div style={styles.dateFilterSection}>
                <span style={{ fontWeight: '600', fontSize: '13px', color: '#4a5568' }}>📅 Date Range:</span>
                <button
                    style={{
                        ...styles.dateFilterButton,
                        ...(dateFilterType === 'all' ? styles.dateFilterButtonActive : {})
                    }}
                    onClick={() => setDateFilterType('all')}
                >
                    All
                </button>
                <button
                    style={{
                        ...styles.dateFilterButton,
                        ...(dateFilterType === 'today' ? styles.dateFilterButtonActive : {})
                    }}
                    onClick={() => setDateFilterType('today')}
                >
                    Today
                </button>
                <button
                    style={{
                        ...styles.dateFilterButton,
                        ...(dateFilterType === 'week' ? styles.dateFilterButtonActive : {})
                    }}
                    onClick={() => setDateFilterType('week')}
                >
                    This Week
                </button>
                <button
                    style={{
                        ...styles.dateFilterButton,
                        ...(dateFilterType === 'month' ? styles.dateFilterButtonActive : {})
                    }}
                    onClick={() => setDateFilterType('month')}
                >
                    This Month
                </button>
                <button
                    style={{
                        ...styles.dateFilterButton,
                        ...(dateFilterType === 'custom' ? styles.dateFilterButtonActive : {})
                    }}
                    onClick={() => setDateFilterType('custom')}
                >
                    Custom
                </button>
                {dateFilterType === 'custom' && (
                    <>
                        <span style={styles.dateFilterDivider}>|</span>
                        <input
                            type="date"
                            value={customStartDate}
                            onChange={(e) => setCustomStartDate(e.target.value)}
                            style={styles.settlementDateInput}
                            placeholder="Start Date"
                        />
                        <span style={{ color: '#718096' }}>to</span>
                        <input
                            type="date"
                            value={customEndDate}
                            onChange={(e) => setCustomEndDate(e.target.value)}
                            style={styles.settlementDateInput}
                            placeholder="End Date"
                        />
                    </>
                )}
            </div>

            {/* Filters */}
            <div style={styles.settlementFilters}>
                <div style={styles.settlementSearchGroup}>
                    <div style={{ position: 'relative', flex: 1 }}>
                        <input
                            type="text"
                            placeholder={getPlaceholderText()}
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            style={{
                                ...styles.settlementSearchInput,
                                borderColor: searchQuery ? '#e66d33' : '#e2e8f0'
                            }}
                            onFocus={(e) => {
                                e.target.style.borderColor = '#e66d33';
                                e.target.style.boxShadow = '0 0 0 3px rgba(230, 109, 51, 0.1)';
                            }}
                            onBlur={(e) => {
                                e.target.style.borderColor = '#e2e8f0';
                                e.target.style.boxShadow = 'none';
                            }}
                        />
                    </div>
                </div>

                <select
                    value={searchType}
                    onChange={(e) => setSearchType(e.target.value)}
                    style={styles.settlementSelect}
                >
                    {searchOptions.map(option => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>

                <select
                    value={selectedStatusFilter}
                    onChange={(e) => setSelectedStatusFilter(e.target.value)}
                    style={{ ...styles.settlementSelect, minWidth: '130px' }}
                >
                    <option value="">All Status</option>
                    {uniqueStatuses.map(status => (
                        <option key={status} value={status}>{status}</option>
                    ))}
                </select>

                <button onClick={clearAllFilters} style={{ ...styles.settlementButton, ...styles.settlementButtonSecondary }}>
                    <Icons.Clear /> Clear
                </button>

                <button onClick={fetchSettlements} style={{ ...styles.settlementButton, ...styles.settlementButtonPrimary }}>
                    <Icons.Refresh /> Refresh
                </button>
                <button onClick={handleExport} style={{ ...styles.settlementButton, ...styles.settlementButtonExport }}>
                    <Icons.Export /> Export All
                </button>
            </div>

            {/* Vendor Dashboard Cards */}
            {Object.keys(filteredVendorGroups).length > 0 ? (
                <div style={styles.vendorDashboardGrid}>
                    {Object.entries(filteredVendorGroups).map(([vendorId, vendorData]) => (
                        <VendorDashboardCard
                            key={vendorId}
                            vendorId={vendorId}
                            vendorData={vendorData}
                            onUpdateStatus={fetchSettlements}
                        />
                    ))}
                </div>
            ) : (
                <div style={styles.settlementEmptyState}>
                    <Icons.NoData />
                    <div style={styles.settlementEmptyStateText}>
                        {settlements.length === 0 ? 'Loading settlements...' : 'No vendors found'}
                    </div>
                    <div style={styles.settlementEmptyStateSubtext}>
                        {settlements.length === 0
                            ? 'Please wait while we fetch the data'
                            : (searchQuery.trim() || selectedStatusFilter || dateFilterType !== 'all')
                                ? 'Try adjusting your filters to see more results'
                                : 'No settlements are available'}
                    </div>
                </div>
            )}

            <style>{`
                @keyframes settlementSlideUp {
                    from { opacity: 0; transform: translateY(30px) scale(0.95); }
                    to { opacity: 1; transform: translateY(0) scale(1); }
                }

                @keyframes settlementFadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }

                @keyframes slideDown {
                    from {
                        opacity: 0;
                        transform: translateY(-10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                .settlement-wrapper {
                    animation: settlementFadeIn 0.4s ease;
                }

                /* Hover effects */
                .vendor-card-header:hover {
                    filter: brightness(1.05);
                }

                .kpi-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(0,0,0,0.08);
                }

                /* Scroll styles */
                ::-webkit-scrollbar {
                    width: 8px;
                    height: 8px;
                }
                ::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 4px;
                }
                ::-webkit-scrollbar-thumb {
                    background: linear-gradient(135deg, #e66d33 0%, #d45a2a 100%);
                    border-radius: 4px;
                }
                ::-webkit-scrollbar-thumb:hover {
                    background: linear-gradient(135deg, #d45a2a 0%, #b84a1a 100%);
                }

                /* Mobile Responsive */
                @media (max-width: 1024px) {
                    .settlement-container {
                        max-width: 95% !important;
                        padding: 10px !important;
                    }
                    .kpi-grid {
                        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)) !important;
                    }
                    .vendor-details-grid {
                        grid-template-columns: 1fr !important;
                    }
                }

                @media (max-width: 768px) {
                    .settlement-container {
                        max-width: 100% !important;
                        padding: 8px !important;
                    }
                    .settlement-filters {
                        flex-direction: column !important;
                        align-items: stretch !important;
                    }
                    .settlement-search-group {
                        min-width: unset !important;
                        flex-direction: column !important;
                    }
                    .settlement-stats-grid {
                        grid-template-columns: repeat(3, 1fr) !important;
                        gap: 8px !important;
                        padding: 12px !important;
                    }
                    .settlement-stat-value {
                        font-size: 18px !important;
                    }
                    .settlement-stat-label {
                        font-size: 10px !important;
                    }
                    .vendor-card-header {
                        padding: 12px 16px !important;
                    }
                    .vendor-header-name {
                        font-size: 15px !important;
                    }
                    .vendor-dashboard-body {
                        padding: 12px !important;
                    }
                    .kpi-grid {
                        grid-template-columns: repeat(2, 1fr) !important;
                        gap: 8px !important;
                    }
                    .kpi-value {
                        font-size: 18px !important;
                    }
                    .vendor-details-grid {
                        grid-template-columns: 1fr !important;
                    }
                    .date-filter-section {
                        flex-wrap: wrap !important;
                        gap: 6px !important;
                        padding: 10px !important;
                    }
                    .date-filter-button {
                        font-size: 10px !important;
                        padding: 4px 10px !important;
                    }
                    .settlement-modal {
                        width: 98% !important;
                        padding: 16px !important;
                    }
                    .settlement-form-row {
                        grid-template-columns: 1fr !important;
                        gap: 10px !important;
                    }
                    .settlement-table {
                        font-size: 10px !important;
                        min-width: 800px !important;
                    }
                    .settlement-table th,
                    .settlement-table td {
                        padding: 4px 6px !important;
                        font-size: 9px !important;
                    }
                    .vendor-settlement-table {
                        font-size: 10px !important;
                    }
                    .vendor-settlement-cell {
                        padding: 4px 6px !important;
                        font-size: 10px !important;
                    }
                    .vendor-settlement-header {
                        font-size: 8px !important;
                        padding: 4px 6px !important;
                    }
                    .settlement-badge {
                        font-size: 8px !important;
                        padding: 2px 6px !important;
                    }
                }

                @media (max-width: 480px) {
                    .settlement-container {
                        padding: 4px !important;
                    }
                    .settlement-stats-grid {
                        grid-template-columns: repeat(2, 1fr) !important;
                    }
                    .kpi-grid {
                        grid-template-columns: 1fr 1fr !important;
                    }
                    .settlement-header {
                        flex-direction: column !important;
                        align-items: flex-start !important;
                    }
                    .vendor-header-right {
                        width: 100% !important;
                        justify-content: flex-start !important;
                    }
                    .vendor-header-stat {
                        font-size: 10px !important;
                        padding: 2px 8px !important;
                    }
                    .settlement-modal {
                        padding: 12px !important;
                    }
                    .settlement-modal-title {
                        font-size: 16px !important;
                    }
                    .vendor-avatar {
                        width: 36px !important;
                        height: 36px !important;
                        font-size: 18px !important;
                    }
                }
            `}</style>
        </div>
    );
};

export default Foodsettlementpage;